import Vue from "vue";
import Vuex from "vuex";
// import axios from "axios";
import provinces from "@/assets/address/provinces.json";
import districts from "@/assets/address/districts.json";
import subdistricts from "@/assets/address/subdistricts.json";
import { getSiteName } from "@/utils/siteName";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    status: "",
    token: localStorage.getItem("token") || "",
    user: {},
    account_id: localStorage.getItem("id_user") || null,
    position_role: localStorage.getItem("position_role") || null,
    pmat_member: {},
    credit_business: [],
    shared_token: "",
    biz_id_meaning: [
      {
        name: "Biz-0",
        detail: "ไม่มีการตรวจสอบ (แบบย่อ)",
      },
      {
        name: "Biz-1",
        detail: "ตรวจสอบเลขผู้เสียภาษีกับสรรพากร หรือ DBD (แบบเต็ม)",
      },
      {
        name: "Biz-2",
        detail:
          "ตรวจสอบตาม Biz-1 และตรวจหลักฐานประกอบเพิ่มเติม <br> เช่น หนังสืออำนาจ หรือหนังสือแต่งตั้ง (สูงสุด)",
      },
    ],

    loading: false,
    loadingDialog: false,
    alerting: false,
    message_alert: null,
    logoutConfirm: false,
    pmatLoginDialog: false,

    register_data: {
      // account_title_th: null,
      first_name_th: null,
      last_name_th: null,
      // account_title_eng: null,
      first_name_eng: null,
      last_name_eng: null,
      // id_card_type: "ID_CARD",
      id_card_num: null,
      email: null,
      phone_number: null,
      date_of_birth: null,
      username: null,
      password: null,
      repassword: null,
      created_by_refcode: null,
    },
    path_term_of_use: null,

    business_id: localStorage.getItem("business_id") || null,
    business_name: localStorage.getItem("business_name") || null,
    business: [
      {
        id: "167039888045635",
        name: "บริษัท เอบีซี จำกัด",
      },
      {
        id: "21412143321682097",
        name: "บริษัท เอ็กซ์วายซีช็อป จำกัด",
      },
    ],
    account_title_list: [],
    disability_list: [],
    universitys: [],
    job_types: [],
    job_positions: [],
    government_job: [],
    employee_type: [],
    degree: [],
    document_types: [],
    language_level: [],
    payment_type: [],
    company_type_all: [],
    company_type_two: [],
    company_type_regiterBIZ: [],
    company_type_other_list: [],
    business_type: [],
    business_sector_list: [],
    regions_list: [],
    provinces_list: [],
    provinces_by_regions_list: [],
    districts_list: [],
    subdistricts_list: [],
    edit_mode_business_data:
      localStorage.getItem("edit_mode_business_data") || false,

    business_data: {
      id: null,
      business_id: null,
      tax_id: null,
      company_type: null,
      business_name_th: null,
      name_on_document_th: null,
      business_name_en: null,
      name_on_document_eng: null,
      branch: {
        ref_id: null,
        branch_no: null,
        branch_name: null,
      },
      business_alias: null,
      trust_level: null,
      location_th: null,
      location_en: null,
      business_logo: [],
      attachment_business_logo: null,
      business_banner: null,
      attachment_business_banner: null,
      business_account_model: null,
      business_sector: null,
      business_type: null,
      business_type_other: null,
      business_detail: null,
      products_and_services: null,
      business_images: [],
      attachment_business_images: [],
      welfare: null,
      website: null,
      email: null,
      tel: null,
      mobile_no: null,
      fax: null,
      organization_size_th: null,
      owner_detail: [],
      address: {
        soi: null,
        yaek: null,
        floor: null,
        amphoe: null,
        moo_no: null,
        street: null,
        tambon: null,
        moo_ban: null,
        room_no: null,
        zipcode: null,
        house_no: null,
        province: null,
        country_name: null,
        building_name: null,
      },
      province_name: null,
      province_code: null,
      district_name: null,
      district_code: null,
      sub_district_name: null,
      sub_district_code: null,
      postal_code: null,
      business_sector_th: null,
      business_sector_en: null,
      business_type_name_th: null,
      business_type_name_en: null,
      company_type_other_th: null,
      company_type_other_en: null,
      company_type_th: null,
      company_type_en: null,
      business_account_model_th: null,
      business_account_model_en: null,
      approve_document: null,
      business_address: null,
      default_address: null,
      website_All: [
        {
          id: 1,
          website: "www.gg.com",
        },
        {
          id: 2,
          website: "www.aaa.com",
        },
        {
          id: 3,
          website: "www.tt.com",
        },
      ],
      contacts: [
        {
          phone_number: "02-123-4568",
          extension: "001",
          contact_name: "Customer Service",
        },
        {
          phone_number: "02-123-4568",
          extension: "002",
          contact_name: "Customer Service",
        },
        {
          phone_number: "024-123-4568",
          extension: "003",
          contact_name: "Customer Service",
        },
      ],

      hcode: null,
      organization_size: "1",
      business_banner_url: "",
      business_logo_url: "",
      business_image_urls: [],
      req_approve_document: [],
    },
    owner_for_business_detail: [
      {
        thai_email: null,
        department: ["owner", "RA"],
        position: ["owner", "RA"],
        first_name_th: null,
        last_name_th: null,
        first_name_eng: null,
        last_name_eng: null,
        id_card_num: null,
        mobile_no: null,
      },
    ],
    business_data_list: [],
    business_total_list: [],

    business_profile: {},
    business_profile_default: {},
    business_profile_edit: {},
    business_data_default: {},

    business_profile_location: {},
    business_profile_location_default: {},
    business_profile_location_edit: {},
    business_profile_location_data: {},

    work_data_list: [],
    work_total_list: [],
    applicant_data_list: [],
    applicant_total_list: [],
    applicant_resume_data: {},
    applicant_profile_list: [],
    applicant_position_list: [],

    gender_list: ["ชาย", "หญิง", "อื่นๆ"],
    driving_ability_list: [
      "รถยนต์",
      "รถบรรทุก",
      "รถกระบะ",
      "รถจักรยานยนต์",
      "อื่นๆ",
    ],
    private_vehicle_list: ["รถยนต์", "รถจักรยานยนต์", "อื่นๆ"],
    latest_login_list: [
      {
        text: "ไม่เกิน 3 วัน",
        value: {
          count: 3,
          type: "day",
        },
      },
      {
        text: "ไม่เกิน 1 สัปดาห์",
        value: {
          count: 7,
          type: "day",
        },
      },
      {
        text: "ไม่เกิน 1 เดือน",
        value: {
          count: 1,
          type: "month",
        },
      },
    ],

    // Talent Search
    filter_list: JSON.parse(localStorage.getItem("list_filter")) || {
      searching: [],
      job_type_ids: [],
      employee_type_ids: [],
      experience_range: [null, null],
      position: [],
      degree: [],
      // location: [
      //   // {
      //   //   region: null,
      //   //   provinces_list: []
      //   // }
      // ], //
      page: 1,
      limitPage: 10,
      select_sort: "most_keyword_relevance",
      tabMenu: 0,
      profile_viewed: null,
      job_offer_status: null,
      has_applications: null,
    },
    advance_filter: JSON.parse(localStorage.getItem("advance_filter")) || {
      business_sector_ids: [],
      edu_institution_ids: [],
      edu_faculty_ids: [],
      edu_keywords: [],
      min_payment: null,
      max_payment: null,
      ability_language_ids: [],
      location: {
        region_id: null,
        province_codes: [],
      },
      ability_driving: [],
      ability_private_vehicle: [],
      latest_login_date: null,
      genders: [],
      disability_ids: [],
      age: [0, 0],
      select_language: false,
      select_driving_ability: false,
      select_private_vehicle: false,
      select_disability: false,
      business_type_ids: [],
    },
    list_candidate: [],
    user_profile_niems: [],

    select_month: "",
    select_year: new Date().getFullYear(),
    years: [],
    months: [],

    count_alert: 0,
    alert_list: [],
    all_alert_list: [],

    noticeDialog: false,

    payment: null,

    user_usage_list_overview: [],
    search_top_list: [],
    search_top100_list: [],
    application_top_list: [],
    application_top100_list: [],
    applied_company_top_list: [],
    applied_company_top100_list: [],
    donut_chart_overview_list: [],
    donut_chart_series_overview: [],
    donut_chart_categories_overview: [],
    radial_chart_list_overview: [],
    recruitment_list_overview: [],
    bar_chart_categories_overview: [],
    bar_chart_series_overview: [],
    work_data_list_for_approve: [],
    work_total_list_for_approve: [],
    data_for_job_tracking: [],
    data_for_tab_tracking: [],
    refcode_list: [],

    // Manage Package
    package_list: [],
    package_public_list: [],
    package_list_for_admin: [],
    package_detail: {
      package_name: null,
      package_detail: null,
      package_price: null,
      unlimited_day: 0,
      cycle_amount: null,
      // month_amount: null,
      // day_amount: null,
      package_size_id: null,
      unlimited_post_job: 0,
      post_job_amount: null,
      unlimited_profile_purchase: 0,
      profile_purchase_amount: null,
      publish_type: "public",
      package_status: "enable",
    },
    package_size: [],
    package_member: [],

    // Credit Tracking
    credit_list_for_admin: [],
    credit_detail_for_admin: [],
    biz_list_for_admin: [],

    biz_recruit_id: localStorage.getItem("biz_recruit_id") || "",
    job_position_name: localStorage.getItem("job_position_name") || "",
    detail_draft: {
      business_id: localStorage.getItem("business_id") || null,
      job_position: null,
      job_position_level: null,
      job_type: null,
      urgent_required: false,
      job_address: localStorage.getItem("default_address") || null,
      employee_type: null,
      job_description: null,
      job_qualification: null,
      job_welfare: localStorage.getItem("default_welfare") || "",
      use_job_contact: null,
      job_contact: null,
      job_contact_name: null,
      job_contact_tel: null,
      job_contact_email: null,
      skill_arr: [],
      url: null,
      job_gender: [],
      req_degree: null,
      degree_required: false,
      transcript_required: false,
      province_name: null,
      district_name: null,
      sub_district_name: null,
      province_code: null,
      district_code: null,
      sub_district_code: null,
      postal_code: null,
      req_language: [
        {
          language_id: null,
          language: null,
          language_level: null,
          language_level_th: null,
          language_required: 0,
          language_other: null,
        },
      ],
      job_amount: null,
      payment_type: null,
      min_salary: null,
      max_salary: null,
      salary_negotiated: false,
      hr_name: null,
      hr_email: null,
      hr_tel: null,
      job_start_date: null,
      job_end_date: null,
      job_payment_start_date: null,
      job_payment_end_date: null,
      job_documents: [],
      job_documents_array_list: [],
      // temp_job_document: [],
      publish_type: "Public",
      req_publish: [],
      job_status: "Draft",
      created_by: localStorage.getItem("user") || null,
      candidate_age_type: 0,
      candidate_min_age: null,
      candidate_max_age: null,
    },
    detail_default: {},
    preview_detail: null,
    preview_job_detail: null,
    list_approve_logs: [],
    personal: {},
    account_resume: null,
    config_list: [],
    file_base64: null,
    status_change_base64: false,
    language_data: [],
    jobtype_data: [],
    employeetype_data: [],
    bizsectors_data: [],
    bizlocation_data: [],
    workstyle_data: [],
    bank_type: [],
    job_position_data: [],
    edu_institution_data: [],
    edu_faculty_data: [],
    default_location_business: null,
    businessMedia: {
      img: [],
      video: [],
    },
    videoUpload: null, // Initialize with null or appropriate default value
    organize: [],
    newsData: [],
    news_draft: {
      title: null,
      new_type_id: null,
      content: null,
      status: null,
      img: [],
      video: [],
      document: [],
    },

    jobData: {
      business_id: "",
      has_end_date: 0,
      job_start_date: "",
      job_end_date: "",
      job_start_time: "",
      job_end_time: "",
      payment_condition: "daily",
      topic_name: "",
      is_single_position: 0,
      topic_status: null,
      edit_allowed: 0,
      recruitments: [
        {
          job_position: "",
          job_type: null,
          employee_type: null,
          job_amount: null,
          showDetails: true,
        },
      ],
      documents: [],
    },
    editBusinessProfileData: {},

    candidateDetail: {},
    candidate_resume: [],
    totalCount: 0,
    activeCount: 0,
    draftCount: 0,
    inactiveCount: 0,
    applications: [],
    dataCount: {},
    excelUrl: "",
    recruitments: [],
    requiredDocuments: [],
    documents: [],
    dialog_wait_payment: null,
    data_job_detail: null,

    siteMaintenanceData: null,
    loadingSiteMaintenance: false,
    scholarship_data: [],

    newsTypes: [],
    serviceUnitTypes: [],
    //Payment State
    paymentCompleted: false,
    businessJoin: false,
    referralSources: [],

    //CSAT SURVEY
    csat_survey: false,
    csat_data: {},
    shared_token_csat: null,

    //FAQ
    referral_status: null,

    //login
    mobile_no_login: null,

    //finger ip
    fingerprint_id_store: null,
    ip_address_store: null,

    //business payment
    business_payment: null,
    business_payment_v2: null,
    job_scoring_url: null,

    //moph dashboard
    area_health: [],
    province_health: [],
    service_type_health: [],
    top_user_zone: [],
    top_post_zone: [],
    last_year: [],
    filter_moph_dashboard: {
      search: "",
      filter_type: "day",
      year: "",
      min: null,
      max: null,
    },
    all_departments: null,
    overview_dashboard_moph: null,
    health_zone_summary: null,
    province_health_zone: [],

    //health rider
    job_health_rider_data: {
      business_id: null,
      job_position: "Health Rider",
      job_status: null,
      job_amount: 0,
      job_start_date: null,
      district_code: [],
      district_name: [],
      sub_district_code: [],
      sub_district_name: [],
    },
    themes: null,
    dialogLogin: false,
    userProfileNiems: null,
    memberNumber: null,

    //user manual
    payment_reject_reasons: [],
    payment_receipt_detail: null,

    application_payment: [],

    code_kku: null,
    certificate_type: [],
    article_job_type: [],
    article_type: [],
    jobFairoo_detail: null,

    workpart_detail_default: {},
    workpart_detail_draft: {
      recruitment_detail: {
        business_id: localStorage.getItem("business_id") || null,
        workpart_name: null,
        cer_id: null,
        article_id: null,
        article_job_id: null,
        product_registration_id: null,
        reward_amount: null,
        public_date: null,
        public_time: null,
        target_audience: "",
        product_detail: "",
        shop_name: null,
        link_google_map: null,
        link_instagram: null,
        link_twitter: null,
        link_facebook: null,
        link_tiktok: null,
        link_youtube: null,
        job_status: "",
      },
      document_files: [
        {
          code: "",
          file_name: null,
          file_path: null,
          file_url: null,
        },
      ],
      customer_detail: {
        customer_contract_name: null,
        contact_time_start: null,
        contact_time_end: null,
        customer_contract_tel: null,
        customer_contract_email: null,
        customer_contract_line: null,
        customer_contract_facebook: null,
        customer_contract_remark: null,
      },
      applications: {
        account_id: null,
      },
    },

    fileArray: [],
    uploadStatus: {},
    biz_recruit_fairoo_id: "",
    users_fairoo_dropdown: {},
    jobs_dropdown: {},

    program_training: [],
    program_training_details: {},
    major_program: [],
    organize_program: [],
    leader_teacher: [],
    operation_unit: [],
    operation_personal: [],
    user_program: [],
    user_app: null,
    trainingAssessments: null,
    assessmentLoading: false,
    assessmentError: null,
    payload_update_payment_array: {
      payment_status: "",
      payments: [
        {
          app_payment_id: null,
          expire_edit_date: "",
          reject_reason_id: null,
          reject_reason_other: "",
          reject_type: "",
        },
      ],
    },
    assessor_list: [],
    signature_training: [],
    announcement_data: {},
    user_business_item:
      JSON.parse(localStorage.getItem("user_business_item")) || null,
  },

  getters: {
    isLoggedIn: (state) => !!state.token,
    themes: (state) => state.themes,
    authStatus: (state) => state.status,
    user: (state) => state.user,
    account_id: (state) => state.account_id,
    position_role: (state) => state.position_role,
    pmat_member: (state) => state.pmat_member,
    credit_business: (state) => state.credit_business,
    shared_token: (state) => state.shared_token,
    shared_token_csat: (state) => state.shared_token_csat,
    biz_id_meaning: (state) => state.biz_id_meaning,

    loading: (state) => state.loading,
    loadingDialog: (state) => state.loadingDialog,
    alerting: (state) => state.alerting,
    message_alert: (state) => state.message_alert,
    logoutConfirm: (state) => state.logoutConfirm,
    pmatLoginDialog: (state) => state.pmatLoginDialog,

    register_data: (state) => state.register_data,
    path_term_of_use: (state) => state.path_term_of_use,

    business_id: (state) => state.business_id,
    business_name: (state) => state.business_name,

    business: (state) => state.business,
    account_title_list: (state) => state.account_title_list,
    disability_list: (state) => state.disability_list,
    universitys: (state) => state.universitys,
    job_types: (state) => state.job_types,
    job_positions: (state) => state.job_positions,
    government_job: (state) => state.government_job,
    employee_type: (state) => state.employee_type,
    degree: (state) => state.degree,
    document_types: (state) => state.document_types,
    bank_type: (state) => state.bank_type,
    language_level: (state) => state.language_level,
    payment_type: (state) => state.payment_type,
    company_type_all: (state) => state.company_type_all,
    company_type_two: (state) => state.company_type_two,
    company_type_regiterBIZ: (state) => state.company_type_regiterBIZ,
    company_type_other_list: (state) => state.company_type_other_list,
    business_type: (state) => state.business_type,
    business_sector_list: (state) => state.business_sector_list,
    regions_list: (state) => state.regions_list,
    provinces_list: (state) => state.provinces_list,
    provinces_by_regions_list: (state) => state.provinces_by_regions_list,
    districts_list: (state) => state.districts_list,
    subdistricts_list: (state) => state.subdistricts_list,

    edit_mode_business_data: (state) => state.edit_mode_business_data,
    business_data: (state) => state.business_data,
    business_data_default: (state) => state.business_data_default,
    business_data_list: (state) => state.business_data_list,
    business_total_list: (state) => state.business_total_list,
    business_profile: (state) => state.business_profile,
    business_profile_default: (state) => state.business_profile_default,
    business_profile_edit(state) {
      if (
        state.editBusinessProfileData &&
        Object.keys(state.editBusinessProfileData).length > 0
      ) {
        return state.editBusinessProfileData;
      }
      return state.business_profile_edit;
    },
    owner_for_business_detail: (state) => state.owner_for_business_detail,

    business_profile_location: (state) => state.business_profile_location,
    business_profile_location_default: (state) =>
      state.business_profile_location_default,
    business_profile_location_edit: (state) =>
      state.business_profile_location_edit,

    work_data_list: (state) => state.work_data_list,
    work_total_list: (state) => state.work_total_list,

    select_month: (state) => state.select_month,
    select_year: (state) => state.select_year,
    years: (state) => state.years,
    months: (state) => state.months,

    user_usage_list_overview: (state) => state.user_usage_list_overview,
    search_top_list: (state) => state.search_top_list,
    search_top100_list: (state) => state.search_top100_list,
    application_top_list: (state) => state.application_top_list,
    application_top100_list: (state) => state.application_top100_list,
    applied_company_top_list: (state) => state.applied_company_top_list,
    applied_company_top100_list: (state) => state.applied_company_top100_list,
    donut_chart_overview_list: (state) => state.donut_chart_overview_list,
    donut_chart_series_overview: (state) => state.donut_chart_series_overview,
    donut_chart_categories_overview: (state) =>
      state.donut_chart_categories_overview,
    radial_chart_list_overview: (state) => state.radial_chart_list_overview,
    recruitment_list_overview: (state) => state.recruitment_list_overview,
    bar_chart_categories_overview: (state) =>
      state.bar_chart_categories_overview,
    bar_chart_series_overview: (state) => state.bar_chart_series_overview,
    work_data_list_for_approve: (state) => state.work_data_list_for_approve,
    work_total_list_for_approve: (state) => state.work_total_list_for_approve,
    data_for_job_tracking: (state) => state.data_for_job_tracking,
    data_for_tab_tracking: (state) => state.data_for_tab_tracking,
    refcode_list: (state) => state.refcode_list,

    // Manage Package
    package_list: (state) => state.package_list,
    package_public_list: (state) => state.package_public_list,
    package_list_for_admin: (state) => state.package_list_for_admin,
    package_detail: (state) => state.package_detail,
    package_size: (state) => state.package_size,
    package_member: (state) => state.package_member,

    // Credit Tracking
    credit_list_for_admin: (state) => state.credit_list_for_admin,
    credit_detail_for_admin: (state) => state.credit_detail_for_admin,
    biz_list_for_admin: (state) => state.biz_list_for_admin,

    applicant_data_list: (state) => state.applicant_data_list,
    applicant_total_list: (state) => state.applicant_total_list,
    applicant_resume_data: (state) => state.applicant_resume_data,
    applicant_profile_list: (state) => state.applicant_profile_list,
    applicant_position_list: (state) => state.applicant_position_list,

    biz_recruit_id: (state) => state.biz_recruit_id,
    preview_detail: (state) => state.preview_detail,
    preview_job_detail: (state) => state.preview_job_detail,
    detail_draft: (state) => state.detail_draft,
    detail_default: (state) => state.detail_default,

    // Talent Search
    gender_list: (state) => state.gender_list,
    driving_ability_list: (state) => state.driving_ability_list,
    private_vehicle_list: (state) => state.private_vehicle_list,
    latest_login_list: (state) => state.latest_login_list,
    filter_list: (state) => state.filter_list,
    advance_filter: (state) => state.advance_filter,
    list_candidate: (state) => state.list_candidate,
    user_profile_niems: (state) => state.user_profile_niems,

    list_approve_logs: (state) => state.list_approve_logs,

    personal: (state) => state.personal,

    account_resume: (state) => state.account_resume,

    config_list: (state) => state.config_list,
    file_base64: (state) => state.file_base64,
    status_change_base64: (state) => state.status_change_base64,

    count_alert: (state) => state.count_alert,
    alert_list: (state) => state.alert_list,
    all_alert_list: (state) => state.all_alert_list,

    noticeDialog: (state) => state.noticeDialog,

    payment: (state) => state.payment,

    language_data: (state) => state.language_data,
    jobtype_data: (state) => state.jobtype_data,
    employeetype_data: (state) => state.employeetype_data,
    bizsectors_data: (state) => state.bizsectors_data,
    bizlocation_data: (state) => state.bizlocation_data,
    workstyle_data: (state) => state.workstyle_data,
    job_position_data: (state) => state.job_position_data,
    edu_institution_data: (state) => state.edu_institution_data,
    edu_faculty_data: (state) => state.edu_faculty_data,
    default_location_business: (state) => state.default_location_business,

    organizationSize: (state) => state.organizationSize,
    businessMedia: (state) => state.businessMedia,
    organize: (state) => state.organize,
    newsData: (state) => state.newsData,
    news_draft: (state) => state.news_draft,
    editBusinessProfileData: (state) => state.editBusinessProfileData,

    candidateDetail: (state) => state.candidateDetail,
    candidate_resume: (state) => state.candidate_resume,

    jobData: (state) => state.jobData,
    totalCount: (state) => state.totalCount,
    activeCount: (state) => state.activeCount,
    draftCount: (state) => state.draftCount,
    inactiveCount: (state) => state.inactiveCount,
    isLoading: (state) => state.loading,
    applications: (state) => state.applications,
    dataCount: (state) => state.dataCount,
    recruitments: (state) => state.recruitments,
    requiredDocuments: (state) => state.requiredDocuments,
    documents: (state) => state.documents,
    excelUrl: (state) => state.excelUrl,
    dialog_wait_payment: (state) => state.dialog_wait_payment,
    data_job_detail: (state) => state.data_job_detail,
    siteMaintenanceData: (state) => state.siteMaintenanceData,
    scholarship_data: (state) => state.scholarship_data,
    newsTypes: (state) => state.newsTypes,
    serviceUnitTypes: (state) => state.serviceUnitTypes,
    businessJoin: (state) => state.businessJoin,

    //FAQ
    referralSources: (state) => state.referralSources,
    referral_status: (state) => state.referral_status,

    //CSAT
    csat_survey: (state) => state.csat_survey,
    csat_data: (state) => state.csat_data,

    //login
    mobile_no_login: (state) => state.mobile_no_login,

    //finger ip
    ip_address_store: (state) => state.ip_address_store,
    fingerprint_id_store: (state) => state.fingerprint_id_store,

    //Business payment
    business_payment: (state) => state.business_payment,
    business_payment_v2: (state) => state.business_payment_v2,

    job_scoring_url: (state) => state.job_scoring_url,

    //moph dashboard
    area_health: (state) => state.area_health,
    province_health: (state) => state.province_health,
    province_health_zone: (state) => state.province_health_zone,
    service_type_health: (state) => state.service_type_health,
    top_user_zone: (state) => state.top_user_zone,
    top_post_zone: (state) => state.top_post_zone,
    last_year: (state) => state.last_year,
    filter_moph_dashboard: (state) => state.filter_moph_dashboard,
    all_departments: (state) => state.all_departments,
    overview_dashboard_moph: (state) => state.overview_dashboard_moph,
    health_zone_summary: (state) => state.health_zone_summary,

    //health rider
    job_health_rider_data: (state) => state.job_health_rider_data,
    dialogLogin: (state) => state.dialogLogin,

    //user manual
    payment_reject_reasons: (state) => state.payment_reject_reasons,
    payment_receipt_detail: (state) => state.payment_receipt_detail,

    application_payment: (state) => state.application_payment,

    code_kku: (state) => state.code_kku,
    workpart_detail_draft: (state) => state.workpart_detail_draft,
    workpart_detail_default: (state) => state.workpart_detail_default,

    certificate_type: (state) => state.certificate_type,
    article_job_type: (state) => state.article_job_type,
    article_type: (state) => state.article_type,
    jobFairoo_detail: (state) => state.jobFairoo_detail,

    fileArray: (state) => state.fileArray,
    biz_recruit_fairoo_id: (state) => state.biz_recruit_fairoo_id,
    users_fairoo_dropdown: (state) => state.users_fairoo_dropdown,
    jobs_dropdown: (state) => state.jobs_dropdown,

    program_training: (state) => state.program_training,
    program_training_details: (state) => state.program_training,
    major_program: (state) => state.major_program,
    organize_program: (state) => state.organize_program,
    leader_teacher: (state) => state.leader_teacher,
    operation_unit: (state) => state.operation_unit,
    operation_personal: (state) => state.operation_personal,
    user_program: (state) => state.user_program,
    user_app: (state) => state.user_app,
    trainingAssessments: (state) => state.trainingAssessments,
    assessmentLoading: (state) => state.assessmentLoading,
    assessmentError: (state) => state.assessmentError,
    payload_update_payment_array: (state) => state.payload_update_payment_array,
    assessor_list: (state) => state.assessor_list,
    signature_training: (state) => state.signature_training,
    announcement_data: (state) => state.announcement_data,
    user_business_item: (state) => state.user_business_item,

    overallProgress: (state) => {
      return state.trainingAssessments?.overall_progress || null;
    },

    pendingAssessmentsCount: (state) => {
      if (!state.trainingAssessments) return 0;

      let count = 0;
      state.trainingAssessments.training_list?.forEach((training) => {
        training.assessments?.forEach((assessment) => {
          if (!assessment.is_completed && assessment.is_mandatory) {
            count++;
          }
        });
      });

      return count;
    },
  },
  mutations: {
    auth_request(state) {
      state.status = "loading";
    },

    auth_success(state, payload) {
      state.status = "success";
      state.token = payload.token;
      // state.user = payload.user
    },
    auth_error(state) {
      state.status = "error";
    },
    username(state, data) {
      localStorage.setItem("user", data);
    },
    setAccountID(state, data) {
      state.account_id = data;
    },
    user_data(state, data) {
      state.user = data;
      const role = data?.role || "4";
      const rolesArray = data?.roles || [];

      let hasSpecialRole = false;
      let checkThemeArr = [
        "WLC_ADMIN",
        "KKU_ADMIN",
        "SPU_ADMIN",
        "PSU_ADMIN",
        "SWU_ADMIN",
      ];

      if (checkThemeArr.includes(process.env.VUE_APP_USE_THEME)) {
        hasSpecialRole = rolesArray.some((r) => r.role === 9);
      } else if (process.env.VUE_APP_USE_THEME === "NIEMS_ADMIN") {
        hasSpecialRole = rolesArray.some((r) => r.role === 8);
      }

      let roles = 0;

      if (hasSpecialRole) {
        roles = checkThemeArr.includes(process.env.VUE_APP_USE_THEME) ? 9 : 8;
      } else {
        const hasRole1 = data?.roles?.some((r) => r.role == 1);
        const hasRole2 = data?.roles?.some((r) => r.role == 2);

        if (hasRole1) {
          roles = 1;
        } else if (hasRole2) {
          roles = 2;
        } else {
          roles = 0;
        }
      }

      localStorage.setItem("role", role);
      localStorage.setItem("roles", roles);
    },
    position_role(state, data) {
      state.position_role = data;
      localStorage.setItem("position_role", data);
    },
    setPMATMember(state, data) {
      state.pmat_member = data;
    },
    setCreditBusiness(state, data) {
      state.credit_business = data;
    },
    setBizIDPMATMember(state, data) {
      localStorage.setItem("biz_id_from_pmat", data);
    },
    setCallBack(state, data) {
      localStorage.setItem("callback", data);
    },
    logout(state) {
      state.status = "";
      state.token = "";

      const keysToRemove = [
        "token",
        "user",
        "id_user",
        "role",
        "user_data",
        "position_role",
        "business_id",
        "business_name",
        "biz_recruit_id",
        "job_position_name",
        "default_address",
        "default_welfare",
        "default_contact",
        "sharetoken",
        "biz_id_from_pmat",
        "callback",
        "default_hr_name",
        "default_hr_tel",
        "default_hr_email",
        "default_location_business",
        "exp_token",
        "business_sector",
        "package",
        "package_code",
        "list_filter",
        "advance_filter",
        "business_profile_location_default",
        "payment",
        "tax",
        "user_business_item",
        "topic_id",
        "resume_id",
        "location_id",
        "biz_recruit_id_job",
        "businessProfile",
        "account_resume",
        "business_profile_completed",
        "role_moph",
        "position_group",
        "first_name_th",
        "last_name_th",
        "job_scoring_url",
        "roles",
        "business_type_fairoo",
        "biz_recruit_fairoo_id",
        "position_id",
        "position",
        "role_training",
        "select_roleAdmin",
      ];

      keysToRemove.forEach((key) => localStorage.removeItem(key));

      if (localStorage.getItem("refcode") === "moph") {
        localStorage.removeItem("refcode");
      }

      let login_sso_kku = localStorage.getItem("login_sso_kku") || "";
      if (process.env.VUE_APP_USE_THEME == "KKU_ADMIN" && login_sso_kku == 1) {
        const url = `${process.env.VUE_APP_REDIRECT_KKU}/logout?app=${process.env.VUE_APP_APP_ID_KKU}`;
        window.location.href = url;
      }
    },
    setSharedToken(state, data) {
      state.shared_token = data;
    },
    setSharedTokenCsatSurvey(state, data) {
      state.shared_token_csat = data;
    },
    SET_MEMBER_NUMBER(state, memberNumber) {
      state.memberNumber = memberNumber;
    },

    onLoading(state) {
      state.loading = true;
    },
    offLoading(state) {
      state.loading = false;
    },
    onLoadingDialog(state) {
      state.loadingDialog = true;
    },
    offLoadingDialog(state) {
      state.loadingDialog = false;
    },
    onAlerting(state, data) {
      state.alerting = true;
      state.message_alert = data;
    },
    offAlerting(state) {
      state.alerting = false;
      state.message_alert = null;
    },
    onLogoutDialog(state) {
      state.logoutConfirm = true;
    },
    offLogoutDialog(state) {
      state.logoutConfirm = false;
    },
    onPMATLoginDialog(state) {
      state.pmatLoginDialog = true;
    },
    offPMATLoginDialog(state) {
      state.pmatLoginDialog = false;
    },

    setBusiness_Id(state, data) {
      // state.business_id = "21412143321682097"
      // localStorage.setItem('business_id', "21412143321682097")
      state.business_id = data;
      localStorage.setItem("business_id", data);
    },
    setBusiness_Name(state, data) {
      state.business_name = data;
      localStorage.setItem("business_name", data);
    },
    setListDataWork(state, data) {
      state.work_data_list = data;
    },
    setListTotalDataWork(state, data) {
      state.work_total_list = data;
    },
    setDefaultLocationBusiness(state, data) {
      localStorage.setItem("default_location_business", JSON.stringify(data));
      state.default_location_business = data;
    },
    setListDataApplicant(state, data) {
      state.applicant_data_list = data;
    },
    setListTotalDataApplicant(state, data) {
      state.applicant_total_list = data;
    },
    setResumeApplicant(state, data) {
      localStorage.setItem("account_resume", data);
    },
    setApplicantProfile(state, data) {
      state.applicant_resume_data = data;
    },
    setApplicantListForProfile(state, data) {
      state.applicant_profile_list = data;
    },
    setApplicantPositionList(state, data) {
      state.applicant_position_list = data;
    },

    SET_DIALOG_JOB(state, value) {
      state.dialog_wait_payment = value;
    },

    setBusinessJoin(state, value) {
      state.businessJoin = value;
    },

    setEditDataBusiness(state, data) {
      state.edit_mode_business_data = data;
      localStorage.setItem("edit_mode_business_data", data);
    },
    resetEditDataBusiness(state) {
      state.edit_mode_business_data = false;
      localStorage.removeItem("edit_mode_business_data");
    },
    setDataBusiness(state, data) {
      state.business_data = data;
    },
    setDataBusinessDefault(state, data) {
      state.business_data_default = data;
    },

    setListDataBusiness(state, { data, reset }) {
      if (reset) {
        state.business_data_list = data;
      } else {
        const updatedList = state.business_data_list.map((item) => {
          const newItem = data.find((d) => d.business_id === item.business_id);
          return newItem ? { ...item, ...newItem } : item;
        });

        const existingIds = state.business_data_list.map(
          (item) => item.business_id
        );
        const newData = data.filter(
          (item) => !existingIds.includes(item.business_id)
        );

        state.business_data_list = [...updatedList, ...newData];
      }
    },
    setListTotalDataBusiness(state, data) {
      state.business_total_list = data;
    },
    setListApproveLogs(state, data) {
      state.list_approve_logs = data;
    },

    // Talent Search
    setFilterList(state, data) {
      localStorage.setItem("list_filter", JSON.stringify(data));
      state.filter_list = data;
    },
    setDefaultFilterList(state) {
      localStorage.removeItem("list_filter");
      state.filter_list = {
        searching: [],
        job_type_ids: [],
        employee_type_ids: [],
        experience_range: [null, null],
        position: [],
        degree: [],
        location: [
          // {
          //   region: null,
          //   provinces_list: []
          // }
        ], //
        page: 1,
        limitPage: 10,
        select_sort: "most_keyword_relevance",
        tabMenu: 0,
        profile_viewed: null,
      };
    },
    setFilterAvance(state, data) {
      localStorage.setItem("advance_filter", JSON.stringify(data));
      state.advance_filter = data;
    },
    setDefaultFilterAvance(state) {
      localStorage.removeItem("advance_filter");
      state.advance_filter = {
        business_sector_ids: [],
        edu_institution_ids: [],
        edu_faculty_ids: [],
        edu_keywords: [],
        min_payment: null,
        max_payment: null,
        ability_language_ids: [],
        // location: [
        //   // {
        //   //   region: null,
        //   //   provinces_list: []
        //   // }
        // ],
        location: {
          region_id: null,
          province_codes: [],
        },
        ability_driving: [],
        ability_private_vehicle: [],
        latest_login_date: null,
        genders: [],
        age: [0, 0],
        disability_ids: [],
        select_language: false,
        select_driving_ability: false,
        select_private_vehicle: false,
        select_disability: false,
        business_type_ids: [],
      };
    },
    setListCandidate(state, data) {
      state.list_candidate = data;
    },
    setUserProfileNiems(state, data) {
      state.user_profile_niems = data;
    },

    setObjectDataBusiness(state, data) {
      state.business_profile = data;

      // Directly access properties from data, no need for data[0]
      localStorage.setItem("default_address", data.business_address || "");
      localStorage.setItem("default_welfare", data.welfare || "");
      localStorage.setItem("default_hr_name", data.hr_name || "");
      localStorage.setItem("default_hr_tel", data.hr_tel || "");
      localStorage.setItem("default_hr_email", data.hr_email || "");
    },
    setObjectDataBusinessDefault(state, data) {
      state.business_profile_default = data;
      // localStorage.setItem('default_address', data[0].default_address)
    },
    setObjectDataBusinessEdit(state, data) {
      state.business_profile_edit = data;
      localStorage.setItem(
        "default_contact",
        JSON.stringify(data.default_contact)
      );
    },

    updateBusinessProfileEdit(state, { field, value }) {
      if (field === "locations") {
        state.business_profile_edit.locations.push(value);
      } else {
        state.business_profile_edit[field] = value;
      }
    },

    resetBusinessProfileEdit(state) {
      state.business_profile_edit = {};
    },

    setObjectDataBusinessLocation(state, data) {
      state.business_profile_location = data;
    },

    setObjectDataBusinessLocationDefault(state, data) {
      state.business_profile_location_default = data;
    },

    setObjectDataLocationEdit(state, data) {
      state.business_profile_location_edit = data;
      localStorage.setItem("default_contact", JSON.stringify(data));
    },

    setBizRecruitId(state, data) {
      state.biz_recruit_id = data;
      localStorage.setItem("biz_recruit_id", data);
    },
    setJobPositionName(state, data) {
      state.job_position_name = data;
      localStorage.setItem("job_position_name", data);
    },
    setObjectDetail(state, data) {
      const defaultContact =
        JSON.parse(localStorage.getItem("default_contact")) || null;

      state.detail_draft = data;
      // localStorage.setItem('detail_draft', data)
      if (defaultContact) {
        if (!data.job_welfare || data.job_welfare === "") {
          data.job_welfare = defaultContact.welfare;
        }

        if (!data.job_contact_email || data.job_contact_email === "") {
          data.job_contact_email = defaultContact.hr_email;
        }

        if (!data.job_contact_name || data.job_contact_name === "") {
          data.job_contact_name = defaultContact.contacts[0].contact_name;
        }

        if (!data.job_contact_tel || data.job_contact_tel === "") {
          data.job_contact_tel = defaultContact.contacts[0].phone_number;
        }

        if (!data.job_address || data.job_address === "") {
          data.job_address = defaultContact.address;
        }
      }
    },
    setObjectDetailDefault(state, data) {
      state.detail_default = data;
      // localStorage.setItem('detail_draft', data)
    },
    setPreviewDetail(state, data) {
      state.preview_detail = data;
      // localStorage.setItem('detail_draft', data)
    },

    // For Admin
    setSelectYearFilter(state, data) {
      state.select_year = data;
    },
    setSelectMonthFilter(state, data) {
      state.select_month = data;
    },
    setYearsFilter(state, data) {
      state.years = data;
    },
    setMonthsFilter(state, data) {
      state.months = data;
    },

    setForUserUsage(state, data) {
      state.user_usage_list_overview = data;
    },
    setTopSearchList(state, data) {
      if (data.top > 6) {
        state.search_top100_list = data.data;
      } else {
        state.search_top_list = data.data;
      }
    },
    setTopApplicationList(state, data) {
      if (data.top > 6) {
        state.application_top100_list = data.data;
      } else {
        state.application_top_list = data.data;
      }
    },
    setTopAppliedCompanyList(state, data) {
      if (data.top > 6) {
        state.applied_company_top100_list = data.data;
      } else {
        state.applied_company_top_list = data.data;
      }
    },
    setForRadialChart(state, data) {
      state.radial_chart_list_overview = data;
    },
    setForDonutChart(state, data) {
      state.donut_chart_overview_list = data.listdata;
      state.donut_chart_categories_overview = data.datas.categories;
      state.donut_chart_series_overview = data.datas.series;
    },
    setForRecruitment(state, data) {
      state.recruitment_list_overview = data;
    },
    setForBarChart(state, data) {
      state.bar_chart_categories_overview = data.categories;
      state.bar_chart_series_overview = data.series;
    },
    setListDataWorkForApprove(state, data) {
      state.work_data_list_for_approve = data;
    },
    setListTotalDataWorkForApprove(state, data) {
      state.work_total_list_for_approve = data;
    },
    setListDataForJobTracking(state, data) {
      state.data_for_job_tracking = data;
    },
    setListDataForTabTracking(state, data) {
      state.data_for_tab_tracking = data;
    },
    setRefCode(state, data) {
      state.refcode_list = data;
    },
    setCodeKKU(state, data) {
      state.code_kku = data;
    },

    //Payment
    SET_PAYMENT_COMPLETED(state, status) {
      state.paymentCompleted = status;
    },

    // Manage Package
    setPackage(state, data) {
      state.package_list = data;
    },
    setPackagePublic(state, data) {
      state.package_public_list = data;
    },
    setPackageAdmin(state, data) {
      state.package_list_for_admin = data;
    },
    setPackageId(state, data) {
      localStorage.setItem("package", data);
    },
    setDetailPackage(state, data) {
      state.package_detail = data;
    },
    setDefaultDetailPackage(state) {
      state.package_detail = {
        package_name: null,
        package_detail: null,
        package_price: null,
        unlimited_day: 0,
        cycle_amount: null,
        // month_amount: null,
        // day_amount: null,
        package_size_id: null,
        unlimited_post_job: 0,
        post_job_amount: null,
        unlimited_profile_purchase: 0,
        profile_purchase_amount: null,
        publish_type: "public",
        package_status: "enable",
      };
    },
    setPackageSize(state, data) {
      state.package_size = data;
    },
    setPackageMember(state, data) {
      state.package_member = data;
    },

    setPackageCodeData(state, data) {
      localStorage.setItem("package_code", data);
    },
    removePackageCodeData() {
      localStorage.removeItem("package_code");
    },

    // Credit tracking
    setCreditAdmin(state, data) {
      state.credit_list_for_admin = data;
    },
    setCreditDetailAdmin(state, data) {
      state.credit_detail_for_admin = data;
    },
    setBizIDListForSuperAdminOrder(state, data) {
      state.biz_list_for_admin = data;
    },

    setDefaultRegister(state) {
      state.register_data = {
        // account_title_th: null,
        first_name_th: null,
        last_name_th: null,
        // account_title_eng: null,
        first_name_eng: null,
        last_name_eng: null,
        // id_card_type: "ID_CARD",
        id_card_num: null,
        email: null,
        phone_number: null,
        date_of_birth: null,
        username: null,
        password: null,
        repassword: null,
        created_by_refcode: null,
      };
    },
    setPathTermOfUse(state, data) {
      state.path_term_of_use = data;
    },
    setFingerPrintId(state, data) {
      state.fingerprint_id_store = data;
    },
    setIpAddress(state, data) {
      state.ip_address_store = data;
    },
    setDefaultData(state) {
      state.detail_draft = {
        business_id: localStorage.getItem("business_id") || null,
        job_position: null,
        job_position_level: null,
        job_type: null,
        urgent_required: false,
        job_address: localStorage.getItem("default_address") || null,
        employee_type: null,
        job_description: null,
        job_qualification: null,
        job_welfare: localStorage.getItem("default_welfare") || "",
        use_job_contact: null,
        job_contact: null,
        job_contact_name: localStorage.getItem("default_hr_name") || "",
        job_contact_tel: localStorage.getItem("default_hr_tel") || "",
        job_contact_email: localStorage.getItem("default_hr_email") || "",
        hr_name: null,
        hr_email: null,
        hr_tel: null,
        skill_arr: [],
        url: null,
        job_gender: [],
        req_degree: null,
        degree_required: false,
        transcript_required: false,
        province_name: null,
        district_name: null,
        sub_district_name: null,
        province_code: null,
        district_code: null,
        sub_district_code: null,
        postal_code: null,
        req_language: [
          {
            language_id: null,
            language: null,
            language_level: null,
            language_level_th: null,
            language_required: 0,
            language_other: null,
          },
        ],
        job_amount: null,
        payment_type: null,
        min_salary: null,
        max_salary: null,
        salary_negotiated: false,
        job_start_date: null,
        job_end_date: null,
        job_payment_start_date: null,
        job_payment_end_date: null,
        job_documents: [],
        job_documents_array_list: [],
        // temp_job_document: [],
        publish_type: "Public",
        req_publish: [],
        job_status: "Draft",
        candidate_age_type: 0,
        candidate_min_age: null,
        candidate_max_age: null,
        created_by: localStorage.getItem("user") || null,
      };
      state.biz_recruit_id = "";
      state.detail_default = {};
      localStorage.removeItem("biz_recruit_id");
    },
    setDefaultObjectDataBusinessEdit(state, data) {
      state.business_data = {
        business_account_model: data,
        business_sector: "",
        company_type: null,
        company_type_th: "",
        company_type_en: "",
        company_type_other_th: "",
        company_type_other_en: "",
        business_name_th: "",
        business_name_en: "",
        business_name_doc_th: "",
        business_name_doc_en: "",
        tax_id: "",
        branch_name: "",
        branch_no: "",
        email: "",
        mobile_no: "",
        tel: "",
        fax: "",
        approve_document: "",
        address: {
          house_no: "",
          room_no: "",
          moo_ban: "",
          moo_no: "",
          building_name: "",
          floor: "",
          yaek: "",
          street: "",
          soi: "",
          province: "",
          tambon: "",
          amphoe: "",
          zipcode: "",
          country: "ไทย",
        },
        province_name: null,
        province_code: null,
        district_name: null,
        district_code: null,
        sub_district_name: null,
        sub_district_code: null,
        postal_code: null,
        entrepreneur_users: [],
        business_address: null,
        default_address: null,
        welfare: null,
        req_approve_document: [],
      };
    },
    setDefaultNews(state, data) {
      state.news_draft = data;
    },
    setOwnerForBusinessDetail(state, data) {
      state.owner_for_business_detail = [
        {
          thai_email: data.thai_email,
          department: "owner",
          position: "owner",
          first_name_th: data.first_name_th,
          last_name_th: data.last_name_th,
          first_name_eng: data.first_name_eng,
          last_name_eng: data.last_name_eng,
          id_card_num: data.id_card_num,
          mobile_no: data.mobile_no,
        },
      ];
      state.business_data.entrepreneur_users = [
        // {
        //   thai_email: data.thai_email,
        //   position: 'owner',
        // }
      ];
    },

    setUserAccountTitle(state, data) {
      state.account_title_list = data;
    },
    setLanguage_level(state, data) {
      state.language_level = data;
    },
    setDisability(state, data) {
      state.disability_list = data;
    },
    setUniversity(state, data) {
      state.universitys = data;
    },
    setDegrees(state, data) {
      state.degree = data;
    },
    setDocuments(state, data) {
      state.document_types = data;
    },
    setBank(state, data) {
      state.bank_type = data;
    },
    setJobTypes(state, data) {
      state.job_types = data;
    },
    setJobPositions(state, data) {
      state.job_positions = data;
    },
    setGovernmentJob(state, data) {
      state.government_job = data;
    },
    setEmployeeType(state, data) {
      state.employee_type = data;
    },
    setPaymentType(state, data) {
      state.payment_type = data;
    },
    setCompanyTypeAll(state, data) {
      state.company_type_all = data;
    },
    setCompanyTypeTwo(state, data) {
      state.company_type_two = data;
    },
    setCompanyTypeRegiterBIZ(state, data) {
      state.company_type_regiterBIZ = data;
    },
    setCompanyTypeOther(state, data) {
      state.company_type_other_list = data;
    },
    setBusinessType(state, data) {
      state.business_type = data;
    },
    setBusinessSector(state, data) {
      state.business_sector_list = data;
    },
    setRegions(state, data) {
      state.regions_list = data;
    },
    setProvinces(state, data) {
      state.provinces_list = data;
    },
    setProvincesByRegions(state, data) {
      state.provinces_by_regions_list = data;
    },
    setDistricts(state, data) {
      state.districts_list = data;
    },
    setSubdistricts(state, data) {
      state.subdistricts_list = data;
    },
    setOrganize(state, data) {
      state.organize = data;
    },
    setNewsData(state, data) {
      state.newsData = data;
    },
    setPersonal(state, data) {
      state.personal = data;
    },
    setAccountId(state, data) {
      state.account_resume = data;
    },
    setConfig(state, data) {
      state.config_list = data;
    },
    setRefcode(state, data) {
      localStorage.setItem("refcode", data);
    },
    setJobDataByRecruitId(state, data) {
      state.data_job_detail = data;
    },
    setLanguageData(state, data) {
      state.language_data = data;
    },
    setJobType(state, data) {
      state.jobtype_data = data;
    },
    setBizSectors(state, data) {
      state.bizsectors_data = data;
    },
    setBizLocation(state, data) {
      state.bizlocation_data = data;
    },
    setWorkStyle(state, data) {
      state.workstyle_data = data;
    },
    setScholarship(state, data) {
      state.scholarship_data = data;
    },
    setJobPosition(state, data) {
      state.job_position_data = data;
    },
    setEduInstitution(state, data) {
      state.edu_institution_data = data;
    },
    setEduFaculty(state, data) {
      state.edu_faculty_data = data;
    },

    setChangeFileURLtoBase64(state, data) {
      state.file_base64 = data;
    },
    setToChangeFileURLtoBase64(state) {
      state.status_change_base64 = true;
    },
    closeToChangeFileURLtoBase64(state) {
      state.status_change_base64 = false;
    },

    setPreviewJobDetail(state, data) {
      state.preview_job_detail = data;
    },

    // Alert
    setCountAlert(state, data) {
      state.count_alert = data;
    },
    setAlertList(state, data) {
      state.alert_list = data;
    },
    setAllAlertList(state, data) {
      state.all_alert_list = data;
    },

    // Notice
    onNoticeDialog(state) {
      state.noticeDialog = true;
    },
    offNoticeDialog(state) {
      state.noticeDialog = false;
    },

    // Organization
    setOrganizationSize(state, organizationSize) {
      state.organizationSize = organizationSize;
    },

    setBusinessMedia(state, media) {
      state.businessMedia.video = media.videos || [];
    },

    setVideoUpload(state, data) {
      // Update the state with the video upload response data
      state.videoUpload = data;
    },
    setMobileLogin(state, data) {
      state.mobile_no_login = data;
    },
    setJobData(state, data) {
      state.jobData = data;
    },
    setBusinessId(state, id) {
      state.business_id = id;
    },
    SET_PAYMENT(state, data) {
      state.payment = data;
    },

    SET_CANDIDATE_DETAIL(state, data) {
      state.candidateDetail = data;
    },
    SET_RESUME_CANDIDATE_DETAIL(state, data) {
      state.candidate_resume = data;
    },

    setTotalCount(state, count) {
      state.totalCount = count;
    },
    setActiveCount(state, count) {
      state.activeCount = count;
    },
    setDraftCount(state, count) {
      state.draftCount = count;
    },
    setInactiveCount(state, count) {
      state.inactiveCount = count;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
    SET_APPLICATIONS(state, applications) {
      state.applications = applications;
    },
    SET_DATA_COUNT(state, dataCount) {
      state.dataCount = dataCount;
    },

    SET_RECRUITMENTS(state, recruitments) {
      state.recruitments = recruitments;
    },
    SET_REQUIRED_DOCUMENTS(state, requiredDocuments) {
      state.requiredDocuments = requiredDocuments;
    },
    SET_DOCUMENTS(state, documents) {
      state.documents = documents;
    },
    SET_EXCEL_URL(state, url) {
      state.excelUrl = url;
    },
    SET_SITE_MAINTENANCE_DATA(state, data) {
      state.siteMaintenanceData = data;
    },
    SET_LOADING_SITE_MAINTENANCE(state, isLoading) {
      state.loadingSiteMaintenance = isLoading;
    },
    SET_NEWS_TYPES(state, newsTypes) {
      state.newsTypes = newsTypes;
    },
    setServiceUnitTypes(state, types) {
      state.serviceUnitTypes = types;
    },
    //FAQ
    setReferralStatus(state, data) {
      state.referral_status = data;
    },
    setReferralSources(state, referralSources) {
      state.referralSources = referralSources;
    },
    //CSAT
    SET_CSAT_SURVEY(state, data) {
      state.csat_survey = data;
    },
    SET_CSAT_DATA(state, data) {
      state.csat_data = data;
    },

    //moph payment
    SET_BUSINESS_PAYMENT(state, data) {
      state.business_payment = data;
    },
    SET_BUSINESS_PAYMENT_V2(state, data) {
      state.business_payment_v2 = data;
    },

    // job scoring url
    SET_JOB_SCORING_URL(state, url) {
      state.job_scoring_url = url;
      localStorage.setItem("job_scoring_url", url);
    },

    SYNC_JOB_SCORING_URL(state) {
      state.job_scoring_url = localStorage.getItem("job_scoring_url") || "";
    },

    //moph dashboard
    setAreaHealth(state, data) {
      state.area_health = data;
    },
    setProvinceHealth(state, data) {
      state.province_health = data;
    },
    setProvinceHealthZone(state, data) {
      state.province_health_zone = data;
    },
    setServiceTypeHealth(state, data) {
      state.service_type_health = data;
    },
    setTopPostZone(state, data) {
      state.top_post_zone = data;
    },
    setTopUserZone(state, data) {
      state.top_user_zone = data;
    },
    setLastYearHealth(state, data) {
      state.last_year = data;
    },
    setFilterMoph(state, data) {
      const updatedData = { ...data };

      if (
        updatedData.year !== "" &&
        updatedData.year !== null &&
        updatedData.year !== undefined
      ) {
        const numericYear = Number(updatedData.year);
        if (numericYear > 2400) {
          updatedData.year = numericYear - 543;
        } else {
          updatedData.year = numericYear;
        }

        const currentYear = new Date().getFullYear();
        if (updatedData.year !== currentYear) {
          updatedData.filter_type = "month";
          updatedData.min = 1;
          updatedData.max = 3;
        }
      }

      if (updatedData.filter_type === "day") {
        if (
          typeof updatedData.min === "number" &&
          typeof updatedData.max === "number" &&
          updatedData.min !== updatedData.max
        ) {
          updatedData.min += 1;
          updatedData.max += 1;
        }
      }

      if (
        updatedData.filter_type === "month" &&
        updatedData.min === 0 &&
        updatedData.max === 11
      ) {
        updatedData.min += 1;
        updatedData.max += 1;
      } else if (updatedData.min == null && updatedData.max == null) {
        updatedData.min = 1;
        updatedData.max = 12;
      }

      state.filter_moph_dashboard = {
        ...state.filter_moph_dashboard,
        ...updatedData,
      };
    },
    setAllDepartments(state, data) {
      state.all_departments = data;
    },
    setOverViewMoph(state, data) {
      state.overview_dashboard_moph = data;
    },
    setHealthZoneSummary(state, data) {
      state.health_zone_summary = data;
    },

    //health rider
    setJobHealthRider(state, data) {
      state.job_health_rider_data = data;
    },
    SET_THEME(state, data) {
      state.themes = data;
    },
    SET_LOGIN_DIALOG(state, value) {
      state.dialogLogin = value;
    },

    setUpdateProfileNiems(state, data) {
      state.userProfileNiems = data;
    },

    //user manual
    SET_PAYMENT_REJECT_REASONS(state, data) {
      state.payment_reject_reasons = data;
    },
    SET_PAYMENT_RECEIPT_DETAIL(state, data) {
      state.payment_receipt_detail = data;
    },
    SET_CLEAR_PAYMENT_RECEIPT_DETAIL(state) {
      state.payment_receipt_detail = null;
    },
    SET_APPLICATION_PAYMENT(state, data) {
      state.application_payment = data;
    },
    SET_Certificate_Types(state, data) {
      state.certificate_type = data;
    },
    SET_Article_Job_Types(state, data) {
      state.article_job_type = data;
    },
    SET_Article_Types(state, data) {
      state.article_type = data;
    },
    SET_JobFairoo_Detail(state, data) {
      state.jobFairoo_detail = data;
    },
    SET_UPLOAD_START(state, { code }) {
      state.uploadStatus[code] = { uploading: true, progress: 0 };
    },
    SET_UPLOAD_PROGRESS(state, { code, progress }) {
      if (state.uploadStatus[code]) {
        state.uploadStatus[code].progress = progress;
      }
    },
    SET_UPLOAD_DONE(state, code) {
      if (state.uploadStatus[code]) {
        state.uploadStatus[code] = { uploading: false, progress: 100 };
        setTimeout(() => delete state.uploadStatus[code], 500);
      }
    },
    ADD_FILE(state, fileData) {
      state.fileArray = state.fileArray.filter((f) => f.code !== fileData.code);
      state.fileArray.push(fileData);
    },
    REMOVE_FILE(state, code) {
      state.fileArray = state.fileArray.filter((f) => f.code !== code);
    },
    SET_biz_recruit_fairoo_id(state, data) {
      state.biz_recruit_fairoo_id = data;
      localStorage.setItem("biz_recruit_fairoo_id", data);
    },
    setWorkPartDetail(state, data) {
      state.workpart_detail_draft = data;
    },
    setWorkPartDefault(state) {
      state.workpart_detail_draft = {
        recruitment_detail: {
          business_id: localStorage.getItem("business_id") || null,
          workpart_name: null,
          cer_id: null,
          article_id: null,
          article_job_id: null,
          product_registration_id: null,
          reward_amount: null,
          public_date: null,
          public_time: null,
          target_audience: "",
          product_detail: "",
          shop_name: null,
          link_google_map: null,
          link_instagram: null,
          link_twitter: null,
          link_facebook: null,
          link_tiktok: null,
          link_youtube: null,
          job_status: "",
        },
        document_files: [
          {
            code: "",
            file_name: null,
            file_path: null,
            file_url: null,
          },
        ],
        customer_detail: {
          customer_contract_name: null,
          contact_time_start: null,
          contact_time_end: null,
          customer_contract_tel: null,
          customer_contract_email: null,
          customer_contract_line: null,
          customer_contract_facebook: null,
          customer_contract_remark: null,
        },
        applications: {
          account_id: null,
        },
      };
      state.biz_recruit_fairoo_id = "";
      state.workpart_detail_default = {};
      state.fileArray = [];
      localStorage.removeItem("biz_recruit_fairoo_id");
    },
    UPDATE_WORKPART_ACCOUNT_ID(state, account_id) {
      state.workpart_detail_draft.applications.account_id = account_id;
    },
    SET_FAIROO_USERS_DROPDOWN(state, data) {
      state.users_fairoo_dropdown = data;
    },
    SET_JOB_DROPDOWN(state, data) {
      state.jobs_dropdown = data;
    },
    SET_PROGRAM_TRAINING(state, data) {
      state.program_training = data;
    },
    SET_PROGRAM_TRAINING_DETAILS(state, data) {
      state.program_training_details = data;
    },
    SET_MAJOR_PROGRAM(state, data) {
      state.major_program = data;
    },
    SET_ORGANIZE_PROGRAM(state, data) {
      state.organize_program = data;
    },
    SET_LEADER_TEACHER(state, data) {
      state.leader_teacher = data;
    },
    SET_OPERATION_UNIT(state, data) {
      state.operation_unit = data;
    },
    SET_OPERATION_PERSONAL(state, data) {
      state.operation_personal = data;
    },
    SET_USER_PROGRAM(state, data) {
      state.user_program = data;
    },
    SET_USER_APP(state, data) {
      state.user_app = data;
    },
    SET_USER_APP_PAYMENT(state, data) {
      state.user_app_payment = data;
    },
    SET_TRAINING_ASSESSMENTS(state, data) {
      state.trainingAssessments = data;
    },
    SET_ASSESSMENT_LOADING(state, loading) {
      state.assessmentLoading = loading;
    },
    SET_ASSESSMENT_ERROR(state, error) {
      state.assessmentError = error;
    },
    CLEAR_TRAINING_ASSESSMENTS(state) {
      state.trainingAssessments = null;
      state.assessmentError = null;
    },
    SET_ASSESSOR_LIST(state, data) {
      state.assessor_list = data;
    },
    SET_PAYLOAD_PAYMENT_ARR(state, data) {
      state.payload_update_payment_array = data;
    },
    SET_DEFAULT_PAYLOAD_PAYMENT_ARR(state) {
      state.payload_update_payment_array = {
        payment_status: "",
        payments: [
          {
            app_payment_id: null,
            expire_edit_date: "",
            reject_reason_id: null,
            reject_reason_other: "",
            reject_type: "",
          },
        ],
      };
    },
    SET_SIGNATURE(state, data) {
      state.signature_training = data;
    },
    SET_ANNOUNCEMENT_DATA(state, data) {
      state.announcement_data = data;
    },
    UPDATE_BUSINESS_ITEM(state, data) {
      state.user_business_item = data;
      localStorage.setItem("user_business_item", JSON.stringify(data));
    },
    CLEAR_SESSION() {
      const keys = [
        "token",
        "user",
        "role",
        "position_id",
        "business_id",
        "id_user",
        "role_training",
        "admin_preview",
        "callback",
      ];

      keys.forEach((k) => localStorage.removeItem(k));

      sessionStorage.clear();
    },
  },
  actions: {
    login({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        Vue.axios({
          url: `${process.env.VUE_APP_BACKEND}/api/v1/business_oauth/login`,
          data: user,
          method: "POST",
          headers: { "Content-type": "application/json" },
        })
          .then((resp) => {
            // console.log("axios login resp ");
            // console.log(resp);
            const token = resp.data.data.access_token;
            // const user = resp.data.user
            // const role = resp.data.role;
            const id_user = resp.data.data.account_id;
            const exp_token = resp.data.data.expiration_date;
            commit("setAccountID", id_user);

            localStorage.setItem("token", token);
            localStorage.setItem("exp_token", exp_token);
            // localStorage.setItem("role", role);
            localStorage.setItem("id_user", id_user);
            // Vue.axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
            commit("auth_success", {
              token: token,
              user: resp.data.data.username,
            });
            commit("username", resp.data.data.username);
            resolve(resp);
          })
          .catch((err) => {
            // console.log(err);
            alert(
              "Username / One Email หรือ รหัสผ่าน ไม่ถูกต้อง\nกรุณาลองใหม่อีกครั้ง"
            );
            commit("offLoading");
            // const message_status = 'Username / One Email หรือ รหัสผ่าน ไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง'
            // commit("onAlerting", { message_status, color:"#58A144" })
            switch (err.code) {
              case 400:
                // console.log("400 error"); // not getting here
                break;
              case 401:
                // console.log("401 error"); // or here
                break;
              default: // end up here all the time
                // console.log("some other error");
                break;
            }
            commit("auth_error");
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            localStorage.removeItem("id_user");
            reject(err);
          });
      });
    },
    async loginByIDcard(
      { commit },
      { id_card_num, mobile_no, fingerprint_id, ip_address, login_site }
    ) {
      try {
        const response = await Vue.axios.post(
          `${process.env.VUE_APP_BACKEND}/v1/login/get_solutions`,
          { id_card_num, mobile_no, fingerprint_id, ip_address, login_site },
          { headers: { "Content-Type": "application/json" } }
        );

        if (response.data.success) {
          commit;
          return response.data;
        } else {
          commit;
          return Promise.reject(response.data);
        }
      } catch (error) {
        return Promise.reject(error);
      }
    },
    loginByShareToken({ commit }, shared_token) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        Vue.axios({
          url: `${process.env.VUE_APP_BACKEND}/api/v1/business_oauth/login_shared_token`,
          data: shared_token,
          method: "POST",
          headers: { "Content-type": "application/json" },
        })
          .then((resp) => {
            // console.log("axios login resp ");
            // console.log(resp);
            const token = resp.data.data.access_token;
            // const user = resp.data.user
            // const role = resp.data.role;
            const id_user = resp.data.data.account_id;
            commit("setAccountID", id_user);

            localStorage.setItem("token", token);
            // localStorage.setItem("role", role);
            localStorage.setItem("id_user", id_user);
            // Vue.axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
            commit("auth_success", {
              token: token,
              user: resp.data.data.username,
            });
            commit("username", resp.data.data.username);
            resolve(resp);
          })
          .catch((err) => {
            // console.log(err);
            alert(
              "Username / One Email หรือ รหัสผ่าน ไม่ถูกต้อง\nกรุณาลองใหม่อีกครั้ง"
            );
            commit("offLoading");
            switch (err.response.status) {
              case 400:
                // console.log("400 error"); // not getting here
                break;
              case 401:
                // console.log("401 error"); // or here
                break;
              default: // end up here all the time
                // console.log("some other error");
                break;
            }
            commit("auth_error");
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            localStorage.removeItem("id_user");
            reject(err);
          });
      });
    },
    loginByShareTokenProvider({ commit }, shared_token) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        Vue.axios({
          url: `${process.env.VUE_APP_BACKEND}/api/v1/business_oauth/login_provider/${shared_token.shared_token}`,
          method: "POST",
          headers: { "Content-type": "application/json" },
        })
          .then((resp) => {
            // console.log("axios login resp ");
            // console.log(resp);
            // console.log(resp);
            const token = resp.data.data.access_token;
            // const user = resp.data.user
            // const role = resp.data.role;
            const id_user = resp.data.data.account_id;
            commit("setAccountID", id_user);

            localStorage.setItem("token", token);
            // localStorage.setItem("role", role);
            localStorage.setItem("id_user", id_user);
            // Vue.axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
            commit("auth_success", {
              token: token,
              user: resp.data.data.username,
            });
            commit("username", resp.data.data.username);
            resolve(resp);
          })
          .catch((err) => {
            console.log(err);
            alert("Token ไม่ถูกต้อง\nกรุณาลองใหม่อีกครั้ง");
            commit("offLoading");
            switch (err.response.status) {
              case 400:
                // console.log("400 error"); // not getting here
                break;
              case 401:
                // console.log("401 error"); // or here
                break;
              default: // end up here all the time
                // console.log("some other error");
                break;
            }
            commit("auth_error");
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            localStorage.removeItem("id_user");
            reject(err);
          });
      });
    },
    loginByCode({ commit }, code) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        Vue.axios({
          url: `${process.env.VUE_APP_BACKEND}/api/v1/business_oauth/login_authorization_code`,
          data: code,
          method: "POST",
          headers: { "Content-type": "application/json" },
        })
          .then((resp) => {
            // console.log("axios login resp ");
            // console.log(resp);
            const token = resp.data.data.access_token;
            // const user = resp.data.user
            // const role = resp.data.role;
            const id_user = resp.data.data.account_id;
            commit("setAccountID", id_user);

            localStorage.setItem("token", token);
            // localStorage.setItem("role", role);
            localStorage.setItem("id_user", id_user);
            // Vue.axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
            commit("auth_success", {
              token: token,
              user: resp.data.data.username,
            });
            commit("username", resp.data.data.username);
            resolve(resp);
          })
          .catch((err) => {
            // console.log(err);
            alert(
              "Username / One Email หรือ รหัสผ่าน ไม่ถูกต้อง\nกรุณาลองใหม่อีกครั้ง"
            );
            commit("offLoading");
            // const message_status = 'Username / One Email หรือ รหัสผ่าน ไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง'
            // commit("onAlerting", { message_status, color:"#58A144" })
            switch (err.response.status) {
              case 400:
                // console.log("400 error"); // not getting here
                break;
              case 401:
                // console.log("401 error"); // or here
                break;
              default: // end up here all the time
                // console.log("some other error");
                break;
            }
            commit("auth_error");
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            localStorage.removeItem("id_user");
            reject(err);
          });
      });
    },
    loginByProviderCode({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        Vue.axios({
          url: `${process.env.VUE_APP_BACKEND}/api/v1/business_oauth/login_oauth_provider`,
          data: data.payload,
          method: "POST",
          headers: { "Content-type": "application/json" },
        })
          .then((resp) => {
            const token = resp.data.data.access_token;
            const id_user = resp.data.data.account_id;
            commit("setAccountID", id_user);

            localStorage.setItem("token", token);
            localStorage.setItem("id_user", id_user);
            commit("auth_success", {
              token: token,
              user: resp.data.data.username,
            });
            commit("username", resp.data.data.username);
            resolve(resp);
          })
          .catch((err) => {
            // console.log(err);
            alert(
              "Username / One Email หรือ รหัสผ่าน ไม่ถูกต้อง\nกรุณาลองใหม่อีกครั้ง"
            );
            commit("offLoading");
            // const message_status = 'Username / One Email หรือ รหัสผ่าน ไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง'
            // commit("onAlerting", { message_status, color:"#58A144" })
            switch (err.response.status) {
              case 400:
                // console.log("400 error"); // not getting here
                break;
              case 401:
                // console.log("401 error"); // or here
                break;
              default: // end up here all the time
                // console.log("some other error");
                break;
            }
            commit("auth_error");
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            localStorage.removeItem("id_user");
            reject(err);
          });
      });
    },
    loginByCodeKKU({ commit }, code) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        Vue.axios({
          url: `${process.env.VUE_APP_BACKEND}/api/v1/business_oauth/login_sso_kku`,
          data: code,
          method: "POST",
          headers: { "Content-type": "application/json" },
        })
          .then((resp) => {
            // console.log("axios login resp ");
            // console.log(resp);
            const token = resp.data.data.access_token;
            // const user = resp.data.user
            // const role = resp.data.role;
            const id_user = resp.data.data.account_id;
            commit("setAccountID", id_user);

            localStorage.setItem("token", token);
            // localStorage.setItem("role", role);
            localStorage.setItem("id_user", id_user);
            // Vue.axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
            localStorage.setItem("login_sso_kku", "1");
            commit("auth_success", {
              token: token,
              user: resp.data.data.username,
            });
            commit("username", resp.data.data.username);
            resolve(resp);
          })
          .catch((err) => {
            // console.log(err);
            alert(
              "Username / One Email หรือ รหัสผ่าน ไม่ถูกต้อง\nกรุณาลองใหม่อีกครั้ง"
            );
            commit("offLoading");
            // const message_status = 'Username / One Email หรือ รหัสผ่าน ไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง'
            // commit("onAlerting", { message_status, color:"#58A144" })
            switch (err.response.status) {
              case 400:
                // console.log("400 error"); // not getting here
                break;
              case 401:
                // console.log("401 error"); // or here
                break;
              default: // end up here all the time
                // console.log("some other error");
                break;
            }
            commit("auth_error");
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            localStorage.removeItem("id_user");
            reject(err);
          });
      });
    },
    loginByAccessToken({ commit }, code) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        Vue.axios({
          url: `${process.env.VUE_APP_BACKEND}/api/v1/business_oauth/niems_training/login_access_token`,
          data: code,
          method: "POST",
          headers: { "Content-type": "application/json" },
        })
          .then((resp) => {
            // console.log("axios login resp ");
            console.log(resp);
            const token = resp.data.data.access_token;
            // const user = resp.data.user
            // const role = resp.data.role;
            const id_user = resp.data.data.account_id;
            commit("setAccountID", id_user);

            localStorage.setItem("token", token);
            // localStorage.setItem("role", role);
            localStorage.setItem("id_user", id_user);
            // Vue.axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
            commit("auth_success", {
              token: token,
              user: resp.data.data.username,
            });
            commit("username", resp.data.data.username);
            resolve(resp);
          })
          .catch((err) => {
            // console.log(err);
            alert(
              "Username / One Email หรือ รหัสผ่าน ไม่ถูกต้อง\nกรุณาลองใหม่อีกครั้ง"
            );
            commit("offLoading");
            // const message_status = 'Username / One Email หรือ รหัสผ่าน ไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง'
            // commit("onAlerting", { message_status, color:"#58A144" })
            switch (err.response.status) {
              case 400:
                // console.log("400 error"); // not getting here
                break;
              case 401:
                // console.log("401 error"); // or here
                break;
              default: // end up here all the time
                // console.log("some other error");
                break;
            }
            commit("auth_error");
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            localStorage.removeItem("id_user");
            reject(err);
          });
      });
    },
    //check lock user
    async fetchLockInfo({ commit }, data) {
      try {
        const response = await Vue.axios.post(
          `${process.env.VUE_APP_BACKEND}/v1/login/check_lock_status`,
          data
        );
        commit;
        return response;
      } catch (error) {
        console.error("Error fetching lock status:", error);
      }
    },
    async logout({ commit }) {
      commit("logout");
    },

    async shareTokenTo({ commit }) {
      let response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_oauth/shared_token`
      );
      commit("setSharedToken", response.data.data.shared_token);
    },

    async getToCheckPMATMember({ commit }) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_user/pmat_payment_status`
      );
      commit("setPMATMember", response.data.data);
    },

    async getCreditBusiness({ commit }, data) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_package_order/credit_balance`,
        {
          headers: {
            "Content-Type": "application/json",
          },
          params: data,
        }
      );
      commit("setCreditBusiness", response.data.data);
    },
    async updateProfilePurchase({ commit }, data) {
      await Vue.axios.post(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_applicant/profile_purchase`,
        data
      );
      commit;
    },
    async updateAddBookmark({ commit }, data) {
      await Vue.axios.put(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_applicant/profile_bookmark`,
        data
      );
      commit;
    },
    async updateAddBookmarkMoph({ commit }, data) {
      await Vue.axios.put(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_applicant/profile_bookmark_moph`,
        data
      );
      commit;
    },

    async getUserData({ commit, dispatch }, site_name) {
      try {
        const THEME = process.env.VUE_APP_USE_THEME;
        const resolvedSiteName =
          THEME === "NIEMS_ADMIN" ? "NIEMS" : site_name || "";

        const url = resolvedSiteName
          ? `${process.env.VUE_APP_BACKEND}/api/v1/business_user/account_detail?site_name=${resolvedSiteName}`
          : `${process.env.VUE_APP_BACKEND}/api/v1/business_user/account_detail?site_name=${THEME}`;

        const response = await Vue.axios.get(url);

        const userData = response.data.data || {};
        // console.log("userData = ", userData);
        const toOwnerDetail = {
          first_name_th: userData.first_name_th || null,
          last_name_th: userData.last_name_th || null,
          first_name_eng: userData.first_name_eng || null,
          last_name_eng: userData.last_name_eng || null,
          thai_email: userData.thai_email || null,
          id_card_num: userData.id_card_num || null,
          mobile_no: userData.mobile_no || null,
        };

        localStorage.setItem("first_name_th", userData.first_name_th);
        localStorage.setItem("last_name_th", userData.last_name_th);
        commit("user_data", userData);
        commit("setOwnerForBusinessDetail", toOwnerDetail);
        return userData;
      } catch (error) {
        console.error("Error fetching user data:", error);
        await dispatch("logout");
        return null;
      }
    },
    async getUpdateDataProvider({ commit }) {
      await Vue.axios.put(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_user/account_and_business_detail_provider`
      );
      commit;
    },
    async getUpdateBusinessUser({ commit }) {
      await Vue.axios.put(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_user/account_and_business_detail`
      );
      // console.log("user_data", user);
      commit;
    },
    async getUpdateBusinessUserNiems({ commit }) {
      await Vue.axios.put(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_user/niems/account_and_business_detail`
      );
      // console.log("user_data", user);
      commit;
    },
    async registerOneID({ commit }, data) {
      await Vue.axios.post(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_user/register_v2`,
        data
      );
      commit;
    },

    async registerBusiness({ commit }, data) {
      await Vue.axios.post(
        `${process.env.VUE_APP_BACKEND}/api/v1/entrepreneur_business/register`,
        data
      );
      // console.log('register business data Full', data);
      commit;
    },
    async registerBusinessLv0V2({ commit }, data) {
      try {
        const response = await Vue.axios.post(
          `${process.env.VUE_APP_BACKEND}/api/v1/entrepreneur_business/register/full_version_lv0_v2`,
          data
        );
        commit;
        return response;
      } catch (error) {
        console.error("Error during registration:", error);
        throw error;
      }
    },
    async registerQuickBusiness({ commit }, data) {
      const response = await Vue.axios.post(
        `${process.env.VUE_APP_BACKEND}/api/v1/entrepreneur_business/register/long_version`,
        data
      );
      // console.log('register business data Quick', response.data);
      commit("setBusiness_Id", response.data.data.business_id);
      commit("setBusiness_Name", response.data.data.business_name_th);
      commit("position_role", "owner");
    },

    // Business Data
    async getBusinessToSelect({ commit }, data) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/entrepreneur_business`,
        {
          headers: {
            "Content-Type": "application/json",
          },
          params: data,
        }
      );

      commit("setListDataBusiness", response.data);
      commit(
        "setListTotalDataBusiness",
        response.data.data_total_all_account_model
      );
      // console.log('object get data', data);
      // commit
      return response.data;
    },

    async getBusinessData({ commit }) {
      const theme = process.env.VUE_APP_USE_THEME;
      const ref_code = localStorage.getItem("refcode");
      const isThemeMOPH =
        ref_code === "moph" || ["MOPH", "MOPH_ADMIN"].includes(theme);
      const getAccountDetail = () => {
        try {
          const accountDetail = localStorage.getItem("account_detail");
          return accountDetail ? JSON.parse(accountDetail) : {};
        } catch (error) {
          console.error("getBusinessData =>", error);
          return {};
        }
      };
      const hasRoleSupderAdmin = getAccountDetail()?.role_moph?.some(
        (r) => r.role === 6
      );
      const roleMophSelected = localStorage.getItem("role_moph") || "";

      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/entrepreneur_business/` +
          localStorage.getItem("business_id") +
          (isThemeMOPH && hasRoleSupderAdmin
            ? `?role_moph=${roleMophSelected}`
            : ``)
      );
      var editDataBusiness = {
        business_account_model: parseInt(
          response.data.data[0].business_account_model
        ),
        business_sector: response.data.data[0].business_sector,
        company_type: parseInt(response.data.data[0].company_type) || null,
        company_type_th: response.data.data[0].company_type_th,
        company_type_en: response.data.data[0].company_type_en,
        company_type_other_th: response.data.data[0].company_type_other_th,
        company_type_other_en: response.data.data[0].company_type_other_en,
        business_name_th: response.data.data[0].business_name_th,
        business_name_en: response.data.data[0].business_name_en,
        business_name_doc_th: response.data.data[0].business_name_doc_th,
        business_name_doc_en: response.data.data[0].business_name_doc_en,
        tax_id: response.data.data[0].tax_id,
        branch_name: response.data.data[0].branch_name,
        branch_no: response.data.data[0].branch_no,
        email: response.data.data[0].email,
        mobile_no: response.data.data[0].mobile_no,
        tel: response.data.data[0].tel,
        province_code:
          response.data.data[0].province_code ||
          response.data.data[0].address.province_code,
        province_name:
          response.data.data[0].province_name ||
          response.data.data[0].address.province_name,
        district_code:
          response.data.data[0].district_code ||
          response.data.data[0].address.district_code,
        district_name:
          response.data.data[0].district_name ||
          response.data.data[0].address.district_name,
        sub_district_code:
          response.data.data[0].sub_district_code ||
          response.data.data[0].address.sub_district_code,
        sub_district_name:
          response.data.data[0].sub_district_name ||
          response.data.data[0].address.sub_district_name,
        postal_code:
          response.data.data[0].postal_code ||
          response.data.data[0].address.postal_code,
        fax: response.data.data[0].fax,
        address: response.data.data[0].address || {
          soi: null,
          yaek: null,
          floor: null,
          amphoe: null,
          moo_no: null,
          street: null,
          tambon: null,
          moo_ban: null,
          room_no: null,
          zipcode: null,
          house_no: null,
          province: null,
          country_name: "ไทย",
          building_name: null,
        },
        business_address: response.data.data[0].business_address,
        trust_level: response.data.data[0].trust_level,
      };

      commit("setDataBusiness", editDataBusiness);
      commit(
        "setDataBusinessDefault",
        JSON.parse(JSON.stringify(editDataBusiness))
      );
    },
    async getBusinessProfile({ commit }) {
      const theme = process.env.VUE_APP_USE_THEME;
      const ref_code = localStorage.getItem("refcode");
      const isThemeMOPH =
        ref_code === "moph" || ["MOPH", "MOPH_ADMIN"].includes(theme);
      const getAccountDetail = () => {
        try {
          const accountDetail = localStorage.getItem("account_detail");
          return accountDetail ? JSON.parse(accountDetail) : {};
        } catch (error) {
          console.error("getBusinessProfile =>", error);
          return {};
        }
      };
      const hasRoleSupderAdmin = getAccountDetail()?.role_moph?.some(
        (r) => r.role === 6
      );
      const roleMophSelected = localStorage.getItem("role_moph") || "";

      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/entrepreneur_business/` +
          localStorage.getItem("business_id") +
          (isThemeMOPH && hasRoleSupderAdmin
            ? `?role_moph=${roleMophSelected}`
            : ``)
      );
      const default_contact = {
        website: response.data.data[0].website || "",
        email: response.data.data[0].email,
        mobile_no: response.data.data[0].mobile_no,
        tel: response.data.data[0].tel,
        call_center: response.data.data[0].call_center || "",
        facebook: response.data.data[0].facebook || "",
        line: response.data.data[0].line || "",
        welfare: response.data.data[0].welfare || "",
        hr_email: response.data.data[0].hr_email || "",
        contacts: response.data.data[0].contacts || [],
        address: response.data.data[0].business_address || "",
      };

      var editProfileBusiness = {
        business_id: response.data.data[0].business_id,
        tax_id: response.data.data[0].tax_id,
        company_type: parseInt(response.data.data[0].company_type) || null,
        business_name_th: response.data.data[0].business_name_th,
        business_name_en: response.data.data[0].business_name_en,
        business_logo: response.data.data[0].business_logo || null,
        business_logo_url: response.data.data[0].business_logo_url || null,
        attachment_business_logo:
          response.data.data[0].attachment_business_logo || null,
        business_type: parseInt(response.data.data[0].business_type) || null,
        business_type_other: response.data.data[0].business_type_other || "",
        business_detail: response.data.data[0].business_detail || "",
        products_and_services:
          response.data.data[0].products_and_services || "",
        trust_level: response.data.data[0].trust_level,
        website: response.data.data[0].website || "",
        email: response.data.data[0].email,
        mobile_no: response.data.data[0].mobile_no,
        tel: response.data.data[0].tel,
        call_center: response.data.data[0].call_center || "",
        facebook: response.data.data[0].facebook || "",
        line: response.data.data[0].line || "",
        business_images: response.data.data[0].business_images || [],
        business_image_urls: response.data.data[0].business_image_urls || [],
        attachment_business_images:
          response.data.data[0].attachment_business_images || [],
        business_address: response.data.data[0].business_address || "",
        default_address: response.data.data[0].default_address,
        position: response.data.data[0].position,
        welfare: response.data.data[0].welfare || "",
        business_banner: response.data.data[0].business_banner || null,
        business_banner_url: response.data.data[0].business_banner_url || null,
        attachment_business_banner:
          response.data.data[0].attachment_business_banner || null,
        default_contact: default_contact,
        hr_name: response.data.data[0].hr_name || "",
        hr_tel: response.data.data[0].hr_tel || "",
        hr_email: response.data.data[0].hr_email || response.data.data[0].email,
        address: response.data.data[0].address || "",
        province_name: response.data.data[0].province_name || null,
        province_code: response.data.data[0].province_code || null,
        district_name: response.data.data[0].district_name || null,
        district_code: response.data.data[0].district_code || null,
        sub_district_name: response.data.data[0].sub_district_name || null,
        sub_district_code: response.data.data[0].sub_district_code || null,
        postal_code: response.data.data[0].postal_code || null,
        business_sector_th: response.data.data[0].business_sector_th || null,
        website_All:
          response.data.data[0].website_All &&
          response.data.data[0].website_All.length == 0
            ? [{ id: 1, website: "" }]
            : response.data.data[0].website_All,
        contacts:
          response.data.data[0].contacts &&
          response.data.data[0].contacts.length == 0
            ? [
                {
                  contact_name: "",
                  extension: "",
                  phone_number: response.data.data[0].mobile_no,
                },
              ]
            : response.data.data[0].contacts,
        latitude: response.data.data[0].latitude || null,
        longitude: response.data.data[0].longitude || null,
        organization_size:
          parseInt(response.data.data[0].organization_size) || null,
        organization_size_th:
          response.data.data[0].organization_size_th || null,
        service_unit_type_id:
          response.data.data[0].service_unit_type_id || null,
        locations: response.data.data[0].locations || [],
        // response.data.data[0].locations &&
        // response.data.data[0].locations.length == 0
        //   ? [
        //       {
        //         id: "",
        //         business_id: "",
        //         branch_name: "",
        //         business_address: "",
        //         province_code: "",
        //         province_name: "",
        //         district_code: "",
        //         district_name: "",
        //         sub_district_code: "",
        //         sub_district_name: "",
        //         postal_code: "",
        //         latitude: "",
        //         longitude: "",
        //         branch_is_main: 0,
        //       },
        //     ]
        //   : response.data.data[0].locations,
        health_zone_th: response.data.data[0].health_zone_th,
        service_unit_type_th: response.data.data[0].service_unit_type_th,
        keyword: response.data.data[0].keyword,
        business_payments: response.data.data[0].business_payments || [],
      };
      var business_location = {
        province_name: response.data.data[0].province_name || null,
        province_code: response.data.data[0].province_code || null,
        district_name: response.data.data[0].district_name || null,
        district_code: response.data.data[0].district_code || null,
        sub_district_name: response.data.data[0].sub_district_name || null,
        sub_district_code: response.data.data[0].sub_district_code || null,
        postal_code: response.data.data[0].postal_code || null,
      };

      const job_scoring_url = response.data.data[0].job_scoring_url;
      commit("SET_JOB_SCORING_URL", job_scoring_url);

      if (ref_code == "moph") {
        localStorage.setItem(
          "business_profile_completed",
          response.data.data[0].business_profile_completed_moph
        );
      } else {
        localStorage.setItem(
          "business_profile_completed",
          response.data.data[0].business_profile_completed
        );
      }

      const business_main = {
        business_name_th: editProfileBusiness.business_name_th || null,
        business_sector_th: editProfileBusiness.business_sector_th || null,
        business_image: editProfileBusiness.business_logo_url || null,
      };

      // localStorage.setItem("user_business_item", JSON.stringify(business_main));
      commit("UPDATE_BUSINESS_ITEM", business_main);
      commit("setDefaultLocationBusiness", business_location);
      commit("setObjectDataBusinessEdit", editProfileBusiness);
      commit(
        "setObjectDataBusinessDefault",
        JSON.parse(JSON.stringify(editProfileBusiness))
      );
      commit("setReferralStatus", response.data.data[0].referral_status);
      commit("setObjectDataBusiness", response.data.data);
    },

    async editBusinessProfile({ commit }, data) {
      await Vue.axios.put(
        `${process.env.VUE_APP_BACKEND}/api/v1/entrepreneur_business/profile/` +
          localStorage.getItem("business_id"),
        data
      );
      commit;
    },
    async editBusinessProfileNew({ commit }, data) {
      await Vue.axios.put(
        `${process.env.VUE_APP_BACKEND}/api/v1/entrepreneur_business/profileV3/` +
          localStorage.getItem("business_id"),
        data
      );
      commit;
    },
    async editBusinessProfileMoph({ commit }, data) {
      await Vue.axios.put(
        `${process.env.VUE_APP_BACKEND}/api/v1/entrepreneur_business/profile_moph/` +
          localStorage.getItem("business_id"),
        data
      );
      commit;
    },
    async registerPaymentBusinessMoph({ commit }, data) {
      await Vue.axios.post(
        `${process.env.VUE_APP_BACKEND}/api/v1/entrepreneur_business/register_payment`,
        data
      );
      commit;
    },
    async getBusinessPayment({ commit }) {
      try {
        const businessId = localStorage.getItem("business_id");
        const response = await Vue.axios.get(
          `${process.env.VUE_APP_BACKEND}/api/v1/business_payment/${businessId}`,
          {
            headers: {
              "Content-type": "application/json",
            },
          }
        );
        commit("SET_BUSINESS_PAYMENT", response.data.data);
        return response.data;
      } catch (error) {
        console.error("Error fetching business payment:", error);
        throw error;
      }
    },
    async getBusinessPaymentV2({ commit }) {
      try {
        const businessId = localStorage.getItem("business_id");
        const response = await Vue.axios.get(
          `${process.env.VUE_APP_BACKEND}/api/v1/entrepreneur_business/payment_v2/${businessId}`,
          {
            headers: {
              "Content-type": "application/json",
            },
          }
        );
        commit("SET_BUSINESS_PAYMENT_V2", response.data.data);
        return response.data;
      } catch (error) {
        console.error("Error fetching business payment:", error);
        throw error;
      }
    },
    resetProfile({ commit }) {
      commit("resetBusinessProfileEdit");
    },

    async editBusinessProfileLocation({ commit }, data) {
      await Vue.axios.put(
        `${process.env.VUE_APP_BACKEND}/api/v1/entrepreneur_business/profile/location/` +
          localStorage.getItem("id"),
        data
      );
      commit;
    },

    async createNewsOnBusiness({ commit }, data) {
      try {
        await Vue.axios.post(
          `${process.env.VUE_APP_BACKEND}/api/v1/entrepreneur_business/business_news/` +
            localStorage.getItem("business_id"),
          data
        );
        commit;

        return { success: true };
      } catch (error) {
        commit("CREATE_NEWS_ERROR", error);
        throw error;
      }
    },

    async updateNewsOnBusiness({ commit }, { businessId, newsId, data }) {
      try {
        await Vue.axios.put(
          `${process.env.VUE_APP_BACKEND}/api/v1/entrepreneur_business/business_news/${businessId}/${newsId}`,
          data
        );
        commit;

        return { success: true };
      } catch (error) {
        commit("UPDATE_NEWS_ERROR", error);
        throw error;
      }
    },
    async getBusinessNews({ commit }, data) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/entrepreneur_business/business_news/` +
          localStorage.getItem("business_id"),
        {
          headers: {
            "Content-Type": "application/json",
          },
          params: data,
        }
      );
      commit("setNewsData", response.data);
    },
    // Work Page
    async saveDraft({ commit }, data) {
      // console.log("object create store", data);

      data.recruitment_detail.req_language =
        data.recruitment_detail.req_language.filter(
          (language) =>
            !Object.values(language).every(
              (value) =>
                value === null || (typeof value === "number" && value === 0)
            )
        );

      const isAllNull = data.recruitment_detail.req_language.every(
        (language) => {
          return Object.values(language).every(
            (value) => value === null || value === undefined
          );
        }
      );

      data.recruitment_detail.req_language = isAllNull
        ? []
        : data.recruitment_detail.req_language;

      if (
        typeof data.recruitment_detail.province_name == "object" &&
        data.recruitment_detail.province_name != null
      ) {
        data.recruitment_detail.province_code =
          data.recruitment_detail.province.provinceCode;
        data.recruitment_detail.province_name =
          data.recruitment_detail.province.provinceNameTh;
      }
      if (
        typeof data.recruitment_detail.district_name == "object" &&
        data.recruitment_detail.district_name != null
      ) {
        data.recruitment_detail.district_code =
          data.recruitment_detail.districtCode;
        data.recruitment_detail.district_name =
          data.recruitment_detail.district_name.districtNameTh;
      }
      if (
        typeof data.recruitment_detail.sub_district_name == "object" &&
        data.recruitment_detail.sub_district_name != null
      ) {
        data.recruitment_detail.sub_district_code =
          data.recruitment_detail.subdistrictCode;
        data.recruitment_detail.sub_district_name =
          data.recruitment_detail.subdistrictNameTh;
      }

      data.site_name = process.env.VUE_APP_USE_THEME;

      await Vue.axios.post(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_recruitment`,
        data
      );
      // console.log('response save', response);
      commit;
    },
    async editData({ commit }, data) {
      // console.log('object edit store', data);
      data.recruitment_detail.req_language =
        data.recruitment_detail.req_language.filter(
          (language) =>
            !Object.values(language).every(
              (value) =>
                value === null || (typeof value === "number" && value === 0)
            )
        );

      const isAllNull = data.recruitment_detail.req_language.every(
        (language) => {
          return Object.values(language).every(
            (value) => value === null || value === undefined
          );
        }
      );

      data.recruitment_detail.req_language = isAllNull
        ? []
        : data.recruitment_detail.req_language;

      data.site_name = process.env.VUE_APP_USE_THEME;

      await Vue.axios.put(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_recruitment/detail/` +
          localStorage.getItem("biz_recruit_id"),
        data
      );
      commit;
    },
    async editStatusRecruitment({ commit }, data) {
      // commit('setBizRecruitId', data)
      data.site_name = process.env.VUE_APP_USE_THEME;
      try {
        const response = await Vue.axios.put(
          `${process.env.VUE_APP_BACKEND}/api/v1/business_recruitment/status/` +
            localStorage.getItem("biz_recruit_id"),
          data
        );
        commit;
        return response;
      } catch (error) {
        return error;
      }
    },
    async deleteRecruitment({ commit }, data) {
      await Vue.axios.delete(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_recruitment/` + data
      );
      // console.log('object data delete', data);
      commit;
    },

    async updateJobDate({ commit }) {
      // commit('setBizRecruitId', data)
      await Vue.axios.put(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_recruitment/refresh_job_date`,
        {
          business_id: localStorage.getItem("business_id"),
        }
      );
      // console.log('object id local', localStorage.getItem("biz_recruit_id"));
      // console.log('object from update status', data);
      commit;
    },
    async getRecruitmentToTableByStatus({ commit }, data) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_recruitment`,
        {
          headers: {
            "Content-Type": "application/json",
          },
          params: data,
        }
      );
      commit("setListDataWork", response.data);
      commit("setListTotalDataWork", response.data);
      // commit
    },
    async getRecruitment({ commit }, data) {
      // commit('setBizRecruitId', data)
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_recruitment/` + data
      );
      let reqLanguageData = [
        {
          language_id: null,
          language: null,
          language_level: null,
          language_level_th: null,
          language_required: 0,
          language_other: null,
        },
      ];
      if (response.data.data[0].req_language.length > 0) {
        reqLanguageData = response.data.data[0].req_language;
      }
      let job_document_list = [];
      if (response.data.data[0].job_documents.length > 0) {
        for (
          let index = 0;
          index < response.data.data[0].job_documents.length;
          index++
        ) {
          job_document_list.push(response.data.data[0].job_documents[index].id);
        }
      }

      // clean &nbsp; , invisible / zero-width characters, newline, trim
      const cleanHtml = (html) => {
        return html
          .replace(/&nbsp;/g, " ")
          .replace(/\u200B/gu, "")
          .replace(/\u200C/gu, "")
          .replace(/\u200D/gu, "")
          .replace(/\uFEFF/gu, "")
          .replace(/[\r\n]+/g, "")
          .trim();
      };

      var detailDraft = {
        business_id: response.data.data[0].business_id,
        job_position: response.data.data[0].job_position,
        job_position_level:
          parseInt(response.data.data[0].job_position_level) || null,
        job_type: parseInt(response.data.data[0].job_type) || null,
        urgent_required: response.data.data[0].urgent_required,
        job_address: response.data.data[0].job_address,
        employee_type: parseInt(response.data.data[0].employee_type) || null,
        job_description: cleanHtml(response.data.data[0].job_description || ""),
        job_qualification: cleanHtml(
          response.data.data[0].job_qualification || ""
        ),
        job_welfare: cleanHtml(response.data.data[0].job_welfare || ""),
        use_job_contact: response.data.data[0].use_job_contact,
        job_contact: response.data.data[0].job_contact,
        job_contact_name: response.data.data[0].job_contact_name,
        job_contact_tel: response.data.data[0].job_contact_tel,
        job_contact_email: response.data.data[0].job_contact_email,
        url: response.data.data[0].url,
        req_degree: parseInt(response.data.data[0].req_degree) || null,
        degree_required: response.data.data[0].degree_required,
        transcript_required: response.data.data[0].transcript_required,
        req_language: reqLanguageData,
        job_amount: response.data.data[0].job_amount,
        payment_type: parseInt(response.data.data[0].payment_type) || null,
        min_salary: response.data.data[0].min_salary,
        max_salary: response.data.data[0].max_salary,
        salary_negotiated: response.data.data[0].salary_negotiated,
        job_start_date: response.data.data[0].job_start_date,
        job_end_date: response.data.data[0].job_end_date,
        job_payment_start_date: response.data.data[0].job_payment_start_date,
        job_payment_end_date: response.data.data[0].job_payment_end_date,
        job_documents: response.data.data[0].job_documents,
        job_gender: response.data.data[0].job_gender,
        hr_name: response.data.data[0].hr_name,
        hr_tel: response.data.data[0].hr_tel,
        hr_email: response.data.data[0].hr_email,
        job_documents_array_list: job_document_list,
        candidate_age_type: response.data.data[0].candidate_age_type ?? 0,
        candidate_min_age: response.data.data[0].candidate_min_age ?? null,
        candidate_max_age: response.data.data[0].candidate_max_age ?? null,
        // temp_job_document: [],
        publish_type: response.data.data[0].publish_type,
        req_publish: response.data.data[0].req_publish,
        job_status: response.data.data[0].job_status,
        created_by: response.data.data[0].created_by,
        skill_arr: response.data.data[0].skill_arr,
        province_name: response.data.data[0].province_name,
        province_code: response.data.data[0].province_code,
        district_name: response.data.data[0].district_name,
        district_code: response.data.data[0].district_code,
        sub_district_name: response.data.data[0].sub_district_name,
        sub_district_code: response.data.data[0].sub_district_code,
        postal_code: response.data.data[0].postal_code,
        payment_data: {
          bank_th: response.data.data[0].bank_th || "",
          bank_id: response.data.data[0].bank_id || null,
          bank_account_no: response.data.data[0].bank_account_no || "",
          bank_account_name: response.data.data[0].bank_account_name || "",
          bank_other_name: response.data.data[0].bank_other_name || "",
        },
      };

      if (typeof detailDraft.skill_arr === "string") {
        detailDraft.skill_arr = JSON.parse(detailDraft.skill_arr);
      }

      commit("setObjectDetail", detailDraft);
      commit("setObjectDetailDefault", JSON.parse(JSON.stringify(detailDraft)));
      commit("setPreviewDetail", response.data.data[0]);
    },

    async postJob({ commit, dispatch }, data) {
      const formattedData = {
        ...data,
        payment_data:
          data.payment_channel === "QR"
            ? data.payment_data
            : data.payment_data_transfer,
        recruitments: data.recruitments.map((recruitment) => ({
          ...recruitment,
          job_type:
            typeof recruitment.job_type === "object"
              ? recruitment.job_type.id
              : recruitment.job_type,
          job_amount:
            recruitment.job_amount !== null
              ? parseInt(recruitment.job_amount, 10)
              : null,
        })),
      };

      if (
        formattedData.payment_channel == "QR" &&
        (formattedData.has_fee == true || formattedData.has_fee == 1)
      ) {
        await dispatch("registerPaymentV2", {
          business_id: localStorage.getItem("business_id"),
          payment_profile: formattedData.payment_profile,
          payment_data: formattedData.payment_data,
          payment_contact: formattedData.payment_contact,
        });
      }

      try {
        formattedData.required_documents =
          formattedData.required_documents.filter((doc) => {
            return !(doc.job_doc_type_id === 8 && !doc.job_doc_type_other_name);
          });

        formattedData.required_other_doc =
          formattedData.required_other_doc.filter((doc) => {
            return !(doc.job_doc_type_id === 8 && !doc.job_doc_type_other_name);
          });

        // const response = await Vue.axios.post(
        //   `${process.env.VUE_APP_BACKEND}/api/v1/business_recruitment/government_job/create`,
        //   formattedData
        // );
        // const response = await Vue.axios.post(
        //   `${process.env.VUE_APP_BACKEND}/api/v1/business_recruitment/government_job_v2/create`,
        //   formattedData
        // );
        const response = await Vue.axios.post(
          `${process.env.VUE_APP_BACKEND}/api/v1/business_recruitment/government_job_v3/create`,
          formattedData
        );

        commit("SET_PAYMENT_COMPLETED", false);

        commit;
        return { success: true, data: response.data };
      } catch (error) {
        console.log("create job:", error);
        throw error;
      }
    },

    async registerPayment({ commit }, paymentData) {
      try {
        await Vue.axios.post(
          `${process.env.VUE_APP_BACKEND}/api/v1/entrepreneur_business/register_payment`,
          paymentData
        );

        commit("SET_PAYMENT_COMPLETED", true);
        return { success: true };
      } catch (error) {
        console.log("register payment: ", error);
        throw error;
      }
    },

    async registerPaymentV2({ commit }, paymentData) {
      try {
        await Vue.axios.post(
          `${process.env.VUE_APP_BACKEND}/api/v1/entrepreneur_business/register_payment_v2`,
          paymentData
        );

        commit("SET_PAYMENT_COMPLETED", true);
        return { success: true };
      } catch (error) {
        console.log("register payment: ", error);
        throw error;
      }
    },

    async updatedJob({ commit }, data) {
      try {
        // let check_payment = localStorage.getItem("payment") || "-";

        const business_id = localStorage.getItem("business_id");
        const topic_id = data.topic_id;

        // const filteredDocuments =
        //   data.required_documents?.filter(
        //     (doc) => doc.job_doc_type_id !== 8 && doc.job_doc_type_id !== null
        //   ) || [];

        // const updatedDocuments = [
        //   ...filteredDocuments,
        //   ...data.required_other_doc,
        // ];

        // if (
        //   !state.paymentCompleted &&
        //   check_payment == "No Payment" &&
        //   (data.has_fee == true || data.has_fee == 1)
        // ) {
        //   await dispatch("registerPayment", {
        //     business_id: localStorage.getItem("business_id"),
        //     payment_profile: data.payment_profile,
        //     payment_data: data.payment_data,
        //     payment_contact: data.payment_contact,
        //   });
        // }

        // data.required_documents = updatedDocuments;

        // if (!Array.isArray(data.recruitments)) {
        //   throw new Error("recruitments is not an array");
        // }

        const formattedData = {
          has_end_date: data.has_end_date,
          job_start_date: data.job_start_date,
          job_end_date: data.job_end_date,
          job_start_time: data.job_start_time,
          job_end_time: data.job_end_time,
          topic_name: data.topic_name,
          topic_status: data.topic_status,
          edit_allowed: data.edit_allowed,
          is_single_position: data.is_single_position,
          recruitments: data.recruitments.map((recruit) => ({
            biz_recruit_id: recruit.biz_recruit_id || null,
            job_position: recruit.job_position,
            job_type:
              typeof recruit.job_type === "object"
                ? recruit.job_type.id
                : recruit.job_type,
            employee_type: recruit.employee_type,
            job_amount: parseInt(recruit.job_amount, 10),
            degree_qualification: recruit.degree_qualification,
            edu_faculty_id: recruit.edu_faculty_id,
            major: recruit.major,
            unit: recruit.unit,
            exam_prefix_code: recruit.exam_prefix_code,
            scholarship_id: recruit.scholarship_id,
            payment_type: recruit.payment_type,
          })),
          documents:
            data.documents?.map((doc) => ({
              originalname: doc.originalname,
              filepath: doc.filepath,
            })) || [],
          has_fee: data.has_fee == 1 || data.has_fee === true ? 1 : 0,
          fee: data.fee,
          job_payment_start_date: data.job_payment_start_date,
          job_payment_end_date: data.job_payment_end_date,
          job_payment_start_time: data.job_payment_start_time,
          job_payment_end_time: data.job_payment_end_time,
          required_documents: data.required_documents,
          payment_condition: data.payment_condition,
          payment_channel: data.payment_channel || "QR",
          payment_data:
            data.payment_channel === "QR"
              ? data.payment_data
              : data.payment_data_transfer,
          payment_contact: data.payment_contact,
          payment_profile: data.payment_profile,
          payment_data_transfer: data.payment_data_transfer,
        };

        // const response = await Vue.axios.put(
        //   `${process.env.VUE_APP_BACKEND}/api/v1/business_recruitment/government_job_v2/update/${business_id}/${topic_id}`,
        //   formattedData
        // );
        const response = await Vue.axios.put(
          `${process.env.VUE_APP_BACKEND}/api/v1/business_recruitment/government_job_v3/update/${business_id}/${topic_id}`,
          formattedData
        );

        commit;

        return { success: true, data: response.data };
      } catch (error) {
        commit("UPDATE_JOB_ERROR", error);
        throw error;
      }
    },
    async getJobMoph({ commit }, data) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_recruitment/government_detail/` +
          data
      );

      commit("setPreviewJobDetail", response.data.data[0]);
    },

    // Applicant Interview Job
    async getApplicantToTableByStatus({ commit }, data) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_application`,
        {
          headers: {
            "Content-Type": "application/json",
          },
          params: data,
        }
      );
      commit("setListDataApplicant", response.data);
      commit("setListTotalDataApplicant", response.data.data_total_all_status);
      // console.log('object get data', data);
      // commit
    },
    async getApplicantProfile({ commit }, data) {
      // const response = await Vue.axios.get(
      //   `${process.env.VUE_APP_BACKEND}/api/v1/business_applicant/profile/` +
      //     data
      // );
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_applicant/profile_by_business`,
        {
          headers: {
            "Content-Type": "application/json",
          },
          params: data,
        }
      );
      commit("setApplicantProfile", response.data);
    },
    async getApplicantProfileMoph({ commit }, data) {
      // const response = await Vue.axios.get(
      //   `${process.env.VUE_APP_BACKEND}/api/v1/business_applicant/profile/` +
      //     data
      // );
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_applicant/profile_by_business_moph`,
        {
          headers: {
            "Content-Type": "application/json",
          },
          params: data,
        }
      );
      commit("setApplicantProfile", response.data);
    },
    async insertStatusApplicant({ commit }, data) {
      await Vue.axios.post(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_application`,
        data
      );
      // console.log('object id local', localStorage.getItem("biz_recruit_id"));
      // console.log('applicate from add status', data);
      commit;
    },
    async editPositionApplicant({ commit }, data) {
      // await Vue.axios.put(
      //   `${process.env.VUE_APP_BACKEND}/api/v1/business_application`,
      //   data
      // );
      // console.log('object id local', localStorage.getItem("biz_recruit_id"));
      console.log("applicate from update status", data);
      commit;
    },
    async getApplicantListForProfile({ commit }, data) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_applicant/application`,
        {
          headers: {
            "Content-Type": "application/json",
          },
          params: data,
        }
      );
      commit("setApplicantListForProfile", response.data);
    },
    async getApplicantPositionList({ commit }, data) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_applicant/job_position`,
        {
          headers: {
            "Content-Type": "application/json",
          },
          params: data,
        }
      );
      commit("setApplicantPositionList", response.data);
    },
    async editStatusApplicant({ commit }, data) {
      // commit('setBizRecruitId', data)
      await Vue.axios.put(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_application`,
        data
      );
      // console.log('object id local', localStorage.getItem("biz_recruit_id"));
      // console.log('applicate from update status', data);
      commit;
    },
    async updateViewResume({ commit }, data) {
      await Vue.axios.put(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_application/resume`,
        data
      );
      commit;
    },

    // Talent Search
    async getListCandidate({ commit }, data) {
      const response = await Vue.axios.post(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_applicant/talent_search`,
        data
      );
      commit("setListCandidate", response.data);
    },
    async getListCandidateMoph({ commit }, data) {
      const response = await Vue.axios.post(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_applicant/talent_search_moph`,
        data
      );
      commit("setListCandidate", response.data);
    },
    async getListCandidateNiems({ commit }, data) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/niems/admin/search`,
        {
          headers: {
            "Content-type": "application/json",
          },
          params: data,
        }
      );
      commit("setListCandidate", response.data);
    },

    async getUserProfileByAccountIdNiems({ commit }, data) {
      const account_id = data.account_id;
      // console.log(account_id)
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/niems/admin/user_profile/${account_id}`
      );
      commit("setUserProfileNiems", response.data);
    },

    // Dashboard For Admin
    // Overview
    async getUserUsageForDashboard({ commit }, data) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_dashboard/user_usage_overview`,
        {
          headers: {
            "Content-Type": "application/json",
          },
          params: data,
        }
      );
      commit("setForUserUsage", response.data.data);
    },
    async getTopSearchList({ commit }, data) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_dashboard/top_job_search`,
        {
          headers: {
            "Content-type": "application/json",
          },
          params: data,
        }
      );
      const detail = {
        data: response.data.data,
        top: data.top,
      };
      commit("setTopSearchList", detail);
    },
    async getTopApplicationList({ commit }, data) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_dashboard/top_job_application`,
        {
          headers: {
            "Content-type": "application/json",
          },
          params: data,
        }
      );
      const detail = {
        data: response.data.data,
        top: data.top,
      };
      commit("setTopApplicationList", detail);
    },
    async getTopAppliedCompanyList({ commit }, data) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_dashboard/top_company_application`,
        {
          headers: {
            "Content-type": "application/json",
          },
          params: data,
        }
      );
      const detail = {
        data: response.data.data,
        top: data.top,
      };
      commit("setTopAppliedCompanyList", detail);
    },
    async getForRadialChart({ commit }, data) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_dashboard/business_sector_overview`,
        {
          headers: {
            "Content-Type": "application/json",
          },
          params: data,
        }
      );
      commit("setForRadialChart", response.data.data);
    },
    async getForDonutChart({ commit }) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_dashboard/user_total_overview`
      );
      // const responseGoal = await Vue.axios.get(`${process.env.VUE_APP_BACKEND}/api/v1/config`)
      // console.log(response.data.data);
      const listdata = response.data.data;
      const categories = ["Employers", "Seekers"];
      const series = [
        listdata.entreprenuer_total || 0,
        listdata.user_total || 0,
      ];
      const datas = { categories, series };
      commit("setForDonutChart", { listdata, datas });
    },
    async getRecruitmentForDashboard({ commit }, data) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_dashboard/recruitment_overview`,
        {
          headers: {
            "Content-Type": "application/json",
          },
          params: data,
        }
      );
      commit("setForRecruitment", response.data.data);
    },
    async getForBarChart({ commit, getters }, data) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_dashboard/recruitment_chart`,
        {
          headers: {
            "Content-type": "application/json",
          },
          params: data,
        }
      );
      const listmonths = getters.months;
      const type = response.data.data_chart.category_type;
      const listdata = response.data.data_chart.series;
      let series = [];
      const listcategories = response.data.data_chart.categories;
      let categories = [];
      for (let index = 0; index < listdata.length; index++) {
        series[index] = {
          name:
            listdata[index].name
              .split("_")
              .join(" ")
              .split(" amount")
              .join("")
              .charAt(0)
              .toUpperCase() +
            listdata[index].name
              .split("_")
              .join(" ")
              .split(" amount")
              .join("")
              .slice(1),
          data: listdata[index].data,
        };
      }
      for (let index = 0; index < listcategories.length; index++) {
        if (type == "monthly" && listcategories.length > 12) {
          const monthName = listmonths.find((data) => {
            return data.id === listcategories[index].month;
          });
          categories[
            index
          ] = `${monthName.name_eng} ${listcategories[index].year}`;
        } else if (type == "weekly") {
          const monthName = listmonths.find((data) => {
            return data.id === listcategories[index].month;
          });
          if (listcategories[index].day.from == listcategories[index].day.to) {
            categories[
              index
            ] = `${listcategories[index].day.from} ${monthName.short_name_eng}`;
          } else {
            categories[
              index
            ] = `${listcategories[index].day.from} - ${listcategories[index].day.to} ${monthName.short_name_eng}`;
          }
        } else {
          const monthName = listmonths.find((data) => {
            return data.id === listcategories[index].month;
          });
          categories[index] = `${monthName.name_eng}`;
        }
      }
      const datas = { status: data.client_type_id, categories, series };
      commit("setForBarChart", datas);
    },
    async getRecruitmentForApproveToTableByStatus({ commit }, data) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_recruitment/approval/status`,
        {
          headers: {
            "Content-Type": "application/json",
          },
          params: data,
        }
      );
      commit("setListDataWorkForApprove", response.data);
      commit("setListTotalDataWorkForApprove", response.data);
      // console.log('object get data', data);
      // commit
    },
    async getRecruitmentApproveLogs({ commit }, data) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_recruitment/approval/logs/` +
          data
      );
      commit("setListApproveLogs", response.data);
      // console.log('object get data', data);
      // commit
    },

    // Ref Code
    async getRefCode({ commit }, data) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/refcode`,
        {
          headers: {
            "Content-type": "application/json",
          },
          params: data,
        }
      );
      commit("setRefCode", response.data);
    },
    async insertRefCode({ commit }, data) {
      await Vue.axios.post(
        `${process.env.VUE_APP_BACKEND}/api/v1/refcode`,
        data
      );
      commit;
    },
    async editRefCode({ commit }, data) {
      await Vue.axios.put(
        `${process.env.VUE_APP_BACKEND}/api/v1/refcode`,
        data
      );
      commit;
    },
    async deleteRefCode({ commit }, data) {
      await Vue.axios.delete(
        `${process.env.VUE_APP_BACKEND}/api/v1/refcode/` + data
      );
      commit;
    },

    // Manage Package
    async getPackage({ commit }, data) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_package`,
        {
          headers: {
            "Content-Type": "application/json",
          },
          params: data,
        }
      );
      commit("setPackage", response.data);
    },
    async getPackagePublic({ commit }, data) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_package/public`,
        {
          headers: {
            "Content-Type": "application/json",
          },
          params: data,
        }
      );
      commit("setPackagePublic", response.data);
    },
    async getPackageAdmin({ commit }, data) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_package`,
        {
          headers: {
            "Content-Type": "application/json",
          },
          params: data,
        }
      );
      commit("setPackageAdmin", response.data);
    },
    async getPackageSize({ commit }) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_package/package_size`
      );
      commit("setPackageSize", response.data.data);
    },
    async getDetailPackage({ commit }) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_package/detail/` +
          localStorage.getItem("package")
      );

      const toPackageDetail = {
        package_code: response.data.data[0].package_code,
        package_name: response.data.data[0].package_name,
        package_detail: response.data.data[0].package_detail,
        package_price: parseInt(response.data.data[0].package_price || 0),
        profile_purchase_amount: parseInt(
          response.data.data[0].profile_purchase_amount || 0
        ),
        unlimited_profile_purchase:
          response.data.data[0].unlimited_profile_purchase,
        // package_size_id: parseInt(response.data.data[0].package_size_id || 0),
        unlimited_post_job: response.data.data[0].unlimited_post_job,
        post_job_amount: parseInt(response.data.data[0].post_job_amount || 0),
        unlimited_day: response.data.data[0].unlimited_day,
        cycle_amount: parseInt(response.data.data[0].cycle_amount || 0),
        // month_amount: parseInt(response.data.data[0].month_amount || 0),
        publish_type: response.data.data[0].publish_type,
        package_status: response.data.data[0].package_status,
      };
      commit("setDetailPackage", toPackageDetail);
    },
    async createPackage({ commit }, data) {
      await Vue.axios.post(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_package`,
        data
      );
      commit;
    },
    async editPackage({ commit }, data) {
      await Vue.axios.put(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_package`,
        data
      );
      commit;
    },
    async deletePackage({ commit }, data) {
      await Vue.axios.delete(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_package/` + data
      );
      commit;
    },

    // Credit tracking
    async getCreditAdmin({ commit }, data) {
      // const response = await Vue.axios.get(`${process.env.VUE_APP_BACKEND}/api/v1/package`, {
      //   headers: {
      //     'Content-Type': 'application/json'
      //   },
      //   params: data
      // })
      console.log(data);
      commit("setCreditAdmin", []);
    },
    async getCreditDetailAdmin({ commit }, data) {
      // const response = await Vue.axios.get(`${process.env.VUE_APP_BACKEND}/api/v1/package`, {
      //   headers: {
      //     'Content-Type': 'application/json'
      //   },
      //   params: data
      // })
      console.log(data);
      commit("setCreditDetailAdmin", []);
    },
    async getBizIDListForSuperAdminOrder({ commit }, data) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_package_order/list_business`,
        {
          headers: {
            "Content-Type": "application/json",
          },
          params: data,
        }
      );
      commit("setBizIDListForSuperAdminOrder", response.data);
    },

    //Job tracking
    async getRecruitmentForJobTrackingToTable({ commit }, data) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_application/tracking`,
        {
          headers: {
            "Content-Type": "application/json",
          },
          params: data,
        }
      );
      commit("setListDataForJobTracking", response);
      commit("setListDataForTabTracking", response.data);
      // commit('setListTotalDataWorkForApprove', response.data)
      // console.log('object get data', data);
      // commit
    },

    // service
    async getUserAccountTitle({ commit }) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_user/register/account_title`
      );
      commit("setUserAccountTitle", response.data.data);
    },
    async getDisability({ commit }) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/user/disability`
      );
      commit("setDisability", response.data.data);
    },
    async getUniversity({ commit }) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/v1/advance_search/university/`
      );
      commit("setUniversity", response.data.data);
    },
    async getLanguage_level({ commit }) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/v1/advance_search/language_level`
      );
      commit("setLanguage_level", response.data.data);
    },
    async getDegrees({ commit }) {
      const theme =
        process.env.VUE_APP_USE_THEME === "KKU_ADMIN" ? "KKU" : "WLC";
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/v1/advance_search/degrees?themes=${theme}`
      );
      commit("setDegrees", response.data.data);
    },
    async getDocumentTypes({ commit }) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/v1/advance_search/job_document_types`
      );
      commit("setDocuments", response.data.data);
    },
    async getBankTypes({ commit }) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/v1/advance_search/bank`
      );
      commit("setBank", response.data.data);
    },
    async getJobTypes({ commit }) {
      let site = localStorage.getItem("refcode") || "-";
      const themes = process.env.VUE_APP_USE_THEME;
      if (site === "moph") {
        const response = await Vue.axios.get(
          `${process.env.VUE_APP_BACKEND}/v1/advance_search/jobtypes`,
          {
            params: {
              provider_type: "providerID",
              themes: "MOPH",
            },
          }
        );
        commit("setJobTypes", response.data.data);
      } else {
        const response = await Vue.axios.get(
          `${process.env.VUE_APP_BACKEND}/v1/advance_search/jobtypes`,
          {
            params: {
              provider_type: "oneID",
              themes: themes,
            },
          }
        );
        commit("setJobTypes", response.data.data);
      }
    },
    async getJobPositions({ commit }) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/v1/advance_search/jobpositions`
      );
      commit("setJobPositions", response.data.data);
    },
    async getGovernmentJob({ commit }) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/v1/advance_search/government_positions`
      );
      commit("setGovernmentJob", response.data.data);
    },
    async getEmployeeType({ commit }) {
      let site = localStorage.getItem("refcode") || "-";
      if (site == "moph") {
        let sector = localStorage.getItem("business_sector");
        if (sector == 1) {
          sector = 1;
        } else {
          sector = 2;
        }

        const response = await Vue.axios.get(
          `${process.env.VUE_APP_BACKEND}/v1/advance_search/employeetype?themes=MOPH`
        );
        commit("setEmployeeType", response.data.data);
      } else {
        const theme =
          process.env.VUE_APP_USE_THEME === "KKU_ADMIN" ? "KKU" : "WLC";
        const response = await Vue.axios.get(
          `${process.env.VUE_APP_BACKEND}/v1/advance_search/employeetype?themes=${theme}`
        );
        commit("setEmployeeType", response.data.data);
      }
    },
    async getPaymentType({ commit }) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/v1/advance_search/payment_type`
      );
      commit("setPaymentType", response.data.data);
    },
    async getCompanyTypeAll({ commit }) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/v1/advance_search/company_type`,
        {
          headers: {
            "Content-Type": "application/json",
          },
          params: {},
        }
      );

      const filteredData = response.data.data.filter(
        (item) =>
          item.business_account_model === "2" ||
          item.business_account_model === null
      );

      commit("setCompanyTypeTwo", filteredData);
      commit("setCompanyTypeAll", response.data.data);
    },
    async getCompanyTypeRegiterBIZ({ commit }) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/v1/advance_search/company_type`,
        {
          headers: {
            "Content-Type": "application/json",
          },
          params: {
            business_account_model: 1,
          },
        }
      );
      commit("setCompanyTypeRegiterBIZ", response.data.data);
    },
    async getCompanyTypeOther({ commit }) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/v1/advance_search/company_type`,
        {
          headers: {
            "Content-Type": "application/json",
          },
          params: {
            business_account_model: 2,
          },
        }
      );
      commit("setCompanyTypeOther", response.data.data);
    },
    async getBusinessType({ commit }) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/v1/advance_search/businesstypes`,
        {
          params: {
            status: 1,
          },
        }
      );
      commit("setBusinessType", response.data.data);
    },
    async getBusinessSector({ commit }) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/v1/advance_search/bizsectors`
      );
      commit("setBusinessSector", response.data.data);
    },
    async getRegions({ commit }) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/user/regions`
      );
      response.data.data.unshift({
        id: null,
        regionNameEn: "AllRegions",
        regionNameTh: "ทั้งหมด",
      });
      commit("setRegions", response.data.data);
      // commit
    },
    async getProvinces({ commit }) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/v1/advance_search/bizlocations`
      );
      commit("setProvinces", response.data.data);
      // commit
    },
    async getProvincesByRegions({ commit }, data) {
      const response = await Vue.axios.post(
        `${process.env.VUE_APP_BACKEND}/api/v1/user/work_location`,
        data
      );
      commit("setProvincesByRegions", response.data.data.province);
      // commit
    },
    async getDistricts({ commit }, data) {
      // const response = await Vue.axios.get(`${process.env.VUE_APP_BACKEND}/v1/advance_search/districts`)
      if (data) {
        let id_provinces = provinces.filter(
          (provinces) => provinces.name.th == data
        );
        let district_list = districts.filter(
          (district) => district.changwat_id === id_provinces[0].id
        );
        commit("setDistricts", district_list);
      }
      // commit
    },
    async getSubdistricts({ commit }, data) {
      // const response = await Vue.axios.get(`${process.env.VUE_APP_BACKEND}/v1/advance_search/subdistricts`)
      let id_provinces = provinces.filter(
        (provinces) => provinces.name.th == data.province
      );
      let id_amphoe = districts.filter(
        (districts) => districts.name.th == data.amphoe
      );
      let tambon = subdistricts.filter(
        (subdistricts) =>
          subdistricts.changwat_id == id_provinces[0].id &&
          subdistricts.amphoe_id == id_amphoe[0].id
      );
      commit("setSubdistricts", tambon);
      // commit
    },
    async getOrganize({ commit }) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/business/public/organization_size`
      );
      commit("setOrganize", response.data.data);
    },

    async changeFileURLtoBase64({ commit }, data) {
      const response = await Vue.axios.post(
        `${process.env.VUE_APP_BACKEND}/api/v1/file/base64`,
        data
      );
      commit("setChangeFileURLtoBase64", response.data.data);
    },

    async getPathTermOfUse({ commit }) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_user/register/path_term_of_use`
      );
      commit("setPathTermOfUse", response.data.data.path);
    },

    // Filter
    async getYearsFilter({ commit }) {
      // const response = await Vue.axios.get(`${process.env.VUE_APP_BACKEND}/api/v1/client_type`)
      const response = {
        data: {
          data: [
            {
              text: "All",
              value: "",
            },
          ],
        },
      };
      const nowYear = new Date().getFullYear();
      const yearAgo = nowYear - 2022;
      for (let i = 0; i <= yearAgo; i++) {
        response.data.data.push({
          text: nowYear - i,
          value: nowYear - i,
        });
      }
      commit("setYearsFilter", response.data.data);
    },
    async getMonthsFilter({ commit }) {
      // const response = await Vue.axios.get(`${process.env.VUE_APP_BACKEND}/api/v1/client_type`)
      const response = {
        data: {
          data: [
            {
              id: "",
              name: "ทั้งหมด",
              short_name: "",
              name_eng: "All",
              short_name_eng: "All",
            },
            {
              id: 1,
              name: "มกราคม",
              short_name: "ม.ค.",
              name_eng: "January",
              short_name_eng: "Jan",
            },
            {
              id: 2,
              name: "กุมภาพันธ์",
              short_name: "ก.พ.",
              name_eng: "February",
              short_name_eng: "Feb",
            },
            {
              id: 3,
              name: "มีนาคม",
              short_name: "มี.ค.",
              name_eng: "March",
              short_name_eng: "Mar",
            },
            {
              id: 4,
              name: "เมษายน",
              short_name: "เม.ย.",
              name_eng: "April",
              short_name_eng: "Apr",
            },
            {
              id: 5,
              name: "พฤษภาคม",
              short_name: "พ.ค.",
              name_eng: "May",
              short_name_eng: "May",
            },
            {
              id: 6,
              name: "มิถุนายน",
              short_name: "มิ.ย.",
              name_eng: "June",
              short_name_eng: "Jun",
            },
            {
              id: 7,
              name: "กรกฎาคม",
              short_name: "ก.ค.",
              name_eng: "July",
              short_name_eng: "Jul",
            },
            {
              id: 8,
              name: "สิงหาคม",
              short_name: "ส.ค.",
              name_eng: "August",
              short_name_eng: "Aug",
            },
            {
              id: 9,
              name: "กันยายน",
              short_name: "ก.ย.",
              name_eng: "September",
              short_name_eng: "Sep",
            },
            {
              id: 10,
              name: "ตุลาคม",
              short_name: "ต.ค.",
              name_eng: "October",
              short_name_eng: "Oct",
            },
            {
              id: 11,
              name: "พฤศจิกายน",
              short_name: "พ.ย.",
              name_eng: "November",
              short_name_eng: "Nov",
            },
            {
              id: 12,
              name: "ธันวาคม",
              short_name: "ธ.ค.",
              name_eng: "December",
              short_name_eng: "Dec",
            },
          ],
        },
      };
      commit("setMonthsFilter", response.data.data);
    },

    async redirectToEditBusiness({ commit }) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/entrepreneur_business/redirect/` +
          localStorage.getItem("business_id")
      );
      console.log("redirectToEditBusiness", response);
      commit;
    },

    async getConfigPublic({ commit }) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/landing_page/config`
      );
      commit("setConfig", response.data.data);
    },

    async getLanguageData({ commit }) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/v1/advance_search/job_language`
      );
      commit("setLanguageData", response.data.data);
    },
    async getBizSectors({ commit }) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/v1/advance_search/bizsectors`
      );
      commit("setBizSectors", response.data.data);
    },
    async getBizLocation({ commit }) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/v1/advance_search/bizlocations`
      );
      commit("setBizLocation", response.data.data);
    },
    async getWorkStyle({ commit }) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/v1/advance_search/working_style`
      );
      commit("setWorkStyle", response.data.data);
    },
    async getJobPosition({ commit }) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/v1/advance_search/jobpositions`
      );
      commit("setJobPosition", response.data.data);
    },
    async getEduInstitution({ commit }) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/v1/advance_search/edu_institution`
      );
      commit("setEduInstitution", response.data.data);
    },
    async getEduFaculty({ commit }) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/v1/advance_search/edu_faculty`
      );
      commit("setEduFaculty", response.data.data);
    },
    async getResumeApplicant({ commit }, data) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_applicant/profile/` +
          data
      );
      localStorage.setItem("account_resume", data);
      commit("setAccountId", data);
      commit("setPersonal", response.data);
      // commit
    },

    // Send Email
    async sendEmail({ commit }, data) {
      await Vue.axios.post(
        `${process.env.VUE_APP_BACKEND}/api/v1/mailbox/inbox_email`,
        data
      );
      commit;
    },

    // Alert
    async getAlertCount({ commit }, data) {
      const params = {
        site_name: getSiteName(),
        ...data,
      };

      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/notification/quantity`,
        {
          headers: {
            "Content-Type": "application/json",
          },
          params,
        }
      );
      commit("setCountAlert", response.data.data);
    },
    async getAlertList({ commit }, data) {
      const params = {
        ...data.filter,
        site_name: getSiteName(),
      };

      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/notification`,
        {
          headers: {
            "Content-Type": "application/json",
          },
          params,
        }
      );

      if (data.all === true) {
        commit("setAllAlertList", response.data);
      } else {
        commit("setAlertList", response.data.data);
      }
    },
    async updateReadAlert({ commit }, data) {
      await Vue.axios.put(
        `${process.env.VUE_APP_BACKEND}/api/v1/notification/read`,
        data
      );
      commit;
    },

    async getBusinessDetails({ commit }) {
      try {
        const response = await Vue.axios.get(
          `${process.env.VUE_APP_BACKEND}/api/v1/business/public/show-business/` +
            localStorage.getItem("business_id"),
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (response.data.success && response.data.data) {
          const apiData = response.data.data;

          const mappedBusinessData = {
            id: apiData.id,
            business_id: apiData.business_id,
            tax_id: apiData.tax_id,
            company_type: apiData.company_type,
            business_name_th: apiData.business_name_th,
            name_on_document_th: apiData.business_name_doc_th,
            business_name_en: apiData.business_name_en,
            name_on_document_eng: apiData.business_name_doc_en,
            branch: {
              ref_id: null,
              branch_no: apiData.branch_no,
              branch_name: apiData.branch_name,
            },
            business_alias: apiData.business_alias,
            trust_level: apiData.trust_level,
            location_th: apiData.location_th,
            location_en: apiData.location_en,
            business_logo: apiData.business_logo,
            attachment_business_logo: null,
            business_banner: apiData.business_banner,
            attachment_business_banner: null,
            business_account_model: apiData.business_account_model,
            business_sector: apiData.business_sector,
            business_type: apiData.business_type,
            business_type_other: apiData.business_type_other,
            business_detail: apiData.business_detail,
            products_and_services: apiData.products_and_services,
            business_images: apiData.business_images || [],
            attachment_business_images: [],
            welfare: apiData.welfare,
            website: apiData.website,
            email: apiData.email,
            tel: apiData.tel,
            mobile_no: apiData.mobile_no,
            fax: apiData.fax,
            organization_size_th: apiData.organization_size_th,
            owner_detail: [],
            address: {
              soi: apiData.soi,
              yaek: apiData.yaek,
              floor: apiData.floor,
              amphoe: apiData.district_name,
              moo_no: apiData.moo_no,
              street: apiData.street,
              tambon: apiData.sub_district_name,
              moo_ban: apiData.moo_ban,
              room_no: apiData.room_no,
              zipcode: apiData.postal_code,
              house_no: apiData.house_no,
              province: apiData.province_name,
              country_name: apiData.country || "ไทย",
              building_name: apiData.building_name,
            },
            province_name: apiData.province_name,
            province_code: apiData.province_code,
            district_name: apiData.district_name,
            district_code: apiData.district_code,
            sub_district_name: apiData.sub_district_name,
            sub_district_code: apiData.sub_district_code,
            postal_code: apiData.postal_code,
            business_sector_th: apiData.business_sector_th,
            business_sector_en: apiData.business_sector_en,
            business_type_name_th: apiData.business_type_name_th,
            business_type_name_en: apiData.business_type_name_en,
            company_type_other_th: apiData.company_type_other_th,
            company_type_other_en: apiData.company_type_other_en,
            company_type_th: apiData.company_type_th,
            company_type_en: apiData.company_type_en,
            business_account_model_th: apiData.business_account_model_th,
            business_account_model_en: apiData.business_account_model_en,
            approve_document: apiData.approve_document,
            business_address: apiData.business_address,
            default_address: apiData.default_address,
            website_All: apiData.website_All || [],
            contacts: apiData.contacts || [],
            business_status: apiData.business_status,
            created_by: apiData.created_by,
            created_at: apiData.created_at,
            updated_by: apiData.updated_by,
            updated_at: apiData.updated_at,
            hcode: apiData.hcode,
            expertise: apiData.expertise,
            moph_station_ref_code: apiData.moph_station_ref_code,
            provider_type: apiData.provider_type,
            organization_size: apiData.organization_size,
            business_banner_url: apiData.business_banner_url || "",
            business_logo_url: apiData.business_logo_url || "",
            business_image_urls: apiData.business_image_urls || [],
          };

          commit("setObjectDataBusiness", mappedBusinessData);
        }
      } catch (error) {
        console.error("Failed to fetch business details:", error);
      }
    },

    async getBusinessMedia({ commit }) {
      try {
        const businessId = localStorage.getItem("business_id");
        if (!businessId) {
          throw new Error("Business ID not found in localStorage.");
        }

        const response = await Vue.axios.get(
          `${process.env.VUE_APP_BACKEND}/api/v1/business/public/business-media/${businessId}`,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        commit("setBusinessMedia", response.data.data);
      } catch (error) {
        console.error("Failed to fetch public business media:", error);
      }
    },

    // Fetches entrepreneur business media
    async getBusinessMediaEntrepreneur({ commit }) {
      try {
        const businessId = localStorage.getItem("business_id");
        if (!businessId) {
          throw new Error("Business ID not found in localStorage.");
        }

        const response = await Vue.axios.get(
          `${process.env.VUE_APP_BACKEND}/api/v1/entrepreneur_business/business-media/${businessId}`,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        commit("setMediaEntrepreneur", response.data.data);
      } catch (error) {
        console.error("Failed to fetch entrepreneur business media:", error);
      }
    },

    async getListVideoUpload({ commit }, data) {
      let formbody = new FormData();
      formbody.append("file", data);

      await Vue.axios.post(
        `${process.env.VUE_APP_BACKEND}/api/v1/file/public/video-upload`,

        formbody
      );

      commit;
    },

    // Updates entrepreneur business media
    async updateBusinessMedia({ commit }, data) {
      try {
        const businessId = localStorage.getItem("business_id");
        if (!businessId) {
          throw new Error("Business ID not found in localStorage.");
        }

        const response = await Vue.axios.put(
          `${process.env.VUE_APP_BACKEND}/api/v1/entrepreneur_business/business-media/${businessId}`,
          data,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        // If you need to commit some mutation after updating, you can do so here.
        commit("updateMediaEntrepreneur", response.data);
      } catch (error) {
        console.error("Failed to update entrepreneur business media:", error);
      }
    },

    async getJobTopicGovernmentDetail({ commit }, topic_id) {
      try {
        const response = await Vue.axios.get(
          `${process.env.VUE_APP_BACKEND}/api/v1/business_recruitment/government_detail/${topic_id}`,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (response.data.data.length > 0) {
          response.data.data[0].recruitments =
            response.data.data[0].recruitments.map((recruitment) => {
              return {
                ...recruitment,
                job_type: parseInt(recruitment.job_type),
                employee_type: parseInt(recruitment.employee_type),
                edu_faculty_id: parseInt(recruitment.edu_faculty_id),
                exam_prefix_code: recruitment.exam_prefix_code || "TT",
                showDetails: true,
              };
            });
        }

        const formattedData = {
          ...response.data.data[0],
          required_other_doc: response.data.data[0].required_documents
            .filter((doc) => doc.job_doc_type_id === 8)
            .map(
              ({ job_doc_type_id, doc_types_th, job_doc_type_other_name }) => ({
                job_doc_type_id,
                doc_types_th,
                job_doc_type_other_name,
              })
            ),
          payment_profile: {
            business_name_th: "",
            business_name_en: "",
            tax_id: "",
            address: "",
            province_code: "",
            province_name: "",
            district_code: "",
            district_name: "",
            sub_district_code: "",
            sub_district_name: "",
            postal_code: "",
            office_number: "",
            website: "",
            authorized_name: "",
            authorized_position: "",
            vat_document: null,
          },
          payment_data: {
            bank_id: "",
            bank_branch: "",
            bank_account_type: "",
            bank_account_no: "",
            bank_account_name: "",
            bank_account_document: null,
          },
          payment_contact: {
            admin_name: "",
            admin_phone_number: "",
            admin_email: "",
            use_admin_contact: false,
            financial_name: "",
            financial_phone_number: "",
            financial_email: "",
            technical_email: "",
          },
        };

        commit("setJobData", formattedData);
      } catch (error) {
        console.error("Failed :", error);
      }
    },
    async getJobByRecruitId({ commit }, params) {
      const {
        biz_recruit_id,
        status = "",
        search = "",
        payment_status = "",
        page = 1,
        limit_per_page = 10,
      } = params;

      try {
        const response = await Vue.axios.get(
          `${process.env.VUE_APP_BACKEND}/api/v1/business_application/workmoph/${biz_recruit_id}`,
          {
            headers: {
              "Content-Type": "application/json",
            },
            params: {
              status,
              search,
              payment_status,
              page,
              limit_per_page,
            },
          }
        );

        commit("setJobDataByRecruitId", response.data);
      } catch (error) {
        console.error("Failed to fetch job detail by recruit id:", error);
      }
    },
    async fetchPaymentData({ commit }) {
      const business_id = localStorage.getItem("business_id");
      try {
        const response = await Vue.axios.get(
          `${process.env.VUE_APP_BACKEND}/api/v1/business_payment/${business_id}`
        );
        if (response.data.message === "NO PAYMENT DATA FOUND") {
          localStorage.setItem("payment", "No Payment");
        } else if (response.data.code === 400) {
          localStorage.setItem("payment", JSON.stringify(0));
        } else if (response.data.code === 200) {
          if (
            response.data.data === null ||
            (Array.isArray(response.data.data) &&
              response.data.data.length === 0)
          ) {
            localStorage.setItem("payment", "No Payment");
          } else if (
            response.data.data &&
            response.data.data.payment_status === null
          ) {
            if (response.data.data.business_id) {
              localStorage.setItem("payment", "Payment Success");
            } else {
              localStorage.setItem("payment", "No Payment");
            }
          } else if (
            response.data.data &&
            typeof response.data.data.payment_status === "string"
          ) {
            localStorage.setItem("payment", response.data.data.payment_status);
          } else {
            localStorage.setItem("payment", "Unknown");
          }
        }
        if (
          response.data &&
          Array.isArray(response.data.data) &&
          response.data.data.length > 0 &&
          response.data.data[0].tax_id
        ) {
          localStorage.setItem("tax", response.data.data[0].tax_id);
        }

        commit("SET_PAYMENT", response.data);
      } catch (error) {
        if (error.message == "NO PAYMENT DATA FOUND") {
          localStorage.setItem("payment", "No Payment");
        } else {
          console.error("Failed to fetch payment data:", error);
          throw error;
        }
      }
    },

    setDialogWaitPayment({ commit }, value) {
      commit("SET_DIALOG_JOB", value);
    },

    async fetchGovernmentJobs(
      { commit },
      {
        business_id,
        status = "Active",
        search = "",
        page = 1,
        limit_per_page = 10,
        sort_by = "DESC",
      }
    ) {
      commit("setError", null);
      const token = localStorage.getItem("token");

      try {
        const response = await Vue.axios.get(
          `/api/v1/business_recruitment/government/${business_id}`,
          {
            params: { status, search, page, limit_per_page, sort_by },
            headers: { authorization: `Bearer ${token}` },
          }
        );

        commit("setJobData", response.data);
        commit("setTotalCount", response.data.dataCount.totalCount);
        commit("setActiveCount", response.data.dataCount.activeCount);
        commit("setDraftCount", response.data.dataCount.draftCount);
        commit("setInactiveCount", response.data.dataCount.inactiveCount);
      } catch (error) {
        commit(
          "setError",
          error.response?.data?.message || "An error occurred"
        );
      }
    },

    async fetchApplications({ commit }, biz_recruit_id) {
      const token = localStorage.getItem("token");

      try {
        const response = await Vue.axios.get(
          `${process.env.VUE_APP_BACKEND}/api/v1/business_application/workmoph/${biz_recruit_id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        if (response.data.success) {
          commit("SET_APPLICATIONS", response.data.data.candidate);
          commit("SET_DATA_COUNT", response.data.data.data_count);
        } else {
          commit("SET_ERROR_MESSAGE", response.data.message);
        }
      } catch (error) {
        commit("SET_ERROR_MESSAGE", "INTERNAL SERVER ERROR");
      }
    },

    async fetchRecruitmentByTopicId({ commit }, biz_recruit_id) {
      const token = localStorage.getItem("token");

      try {
        const response = await Vue.axios.get(
          `/api/v1/business_application/workmoph/recruitment/${biz_recruit_id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        if (response.data.success) {
          commit("SET_RECRUITMENTS", response.data.data.recruitments);
          commit(
            "SET_REQUIRED_DOCUMENTS",
            response.data.data.required_documents
          );
          commit("SET_DOCUMENTS", response.data.data.documents);
        } else {
          commit("SET_ERROR_MESSAGE", response.data.message);
        }
      } catch (error) {
        commit("SET_ERROR_MESSAGE", "INTERNAL SERVER ERROR");
      }
    },

    async exportCandidatesByBizRecruitId({ commit }, biz_recruit_id) {
      const token = localStorage.getItem("token");

      try {
        const response = await Vue.axios.get(
          `${process.env.VUE_APP_BACKEND}/api/v1/business_application/workmoph/candidate_detail/excel/${biz_recruit_id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        if (response.data.success) {
          commit("SET_EXCEL_URL", response.data.data);
        } else {
          commit("SET_ERROR_MESSAGE", response.data.message);
        }
      } catch (error) {
        commit("SET_ERROR_MESSAGE", "INTERNAL SERVER ERROR");
      }
    },

    ////4/////
    async fetchCandidateDetail({ commit }, app_id) {
      const token = localStorage.getItem("token");

      try {
        const response = await Vue.axios.get(
          `${process.env.VUE_APP_BACKEND}/api/v1/business_application/workmoph/candidate_detail/${app_id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        if (response.data.success) {
          commit("SET_CANDIDATE_DETAIL", response.data.data);
          commit("SET_RESUME_CANDIDATE_DETAIL", response.data.data);
          return response.data.data;
        } else {
          commit("SET_ERROR", response.data.message);
          return null;
        }
      } catch (error) {
        const errorMessage =
          error.response?.data?.message || "INTERNAL SERVER ERROR";
        commit("SET_ERROR", errorMessage);
        return error;
      }
    },
    async fetchSiteMaintenance({ commit, state }) {
      if (state.loadingSiteMaintenance) return;

      commit("SET_LOADING_SITE_MAINTENANCE", true);
      try {
        const response = await Vue.axios.get(
          `${process.env.VUE_APP_BACKEND}/api/v1/site_maintenance`,
          {
            params: {
              site_name: "WorkSpace MOPH",
              providetype: "provideID",
              domain: "mophworkspace.com",
            },
          }
        );

        if (response.data.success) {
          commit("SET_SITE_MAINTENANCE_DATA", response.data.data);
        }
      } catch (error) {
        console.error("Internal Server Error:", error);
      } finally {
        commit("SET_LOADING_SITE_MAINTENANCE", false);
      }
    },
    async getScholarship({ commit }) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/v1/advance_search/scholarship`
      );

      commit("setScholarship", response.data.data);
    },

    async fetchBusinessNewsTypes({ commit }) {
      try {
        const response = await Vue.axios.get(
          `${process.env.VUE_APP_BACKEND}/v1/advance_search/business_news_types`
          // ,
          // {
          //   params: {
          //     new_types: data,
          //   },
          // }
        );
        commit("SET_NEWS_TYPES", response.data.data);
      } catch (error) {
        console.error("Error fetching business news types:", error);
      }
    },

    //CSAT SURVEY
    async fetchCsatSurvey({ commit }, { biz_id, site }) {
      try {
        const response = await Vue.axios.get(
          `${process.env.VUE_APP_BACKEND}/api/v1/csat_survey/check_business/csat_survey`,
          {
            params: {
              biz_id,
              site,
            },
          }
        );
        commit("SET_CSAT_SURVEY", response.data.data.prompt_survey);
        commit("SET_CSAT_DATA", response.data.data);
      } catch (error) {
        console.error("Error fetching csat survey:", error);
      }
    },
    async shareTokenToCsatSurvey({ commit }, { biz_id, site }) {
      try {
        let response = await Vue.axios.post(
          `${process.env.VUE_APP_BACKEND}/api/v1/csat_survey/csat_survey_business`,
          { biz_id, site }
        );
        commit("setSharedTokenCsatSurvey", response.data.data.survey_token);
        return response.data.data;
      } catch (error) {
        console.error("Error sharing token:", error);
      }
    },
    async updateSurveyStatus({ commit }, payload) {
      try {
        await Vue.axios.put(
          `${process.env.VUE_APP_BACKEND}/api/v1/csat_survey/csat_survey_business`,
          payload
        );
        commit;
      } catch (error) {
        console.error("Error fetching update csat survey:", error);
      }
    },

    //New register
    async fetchBusinessInfoByTaxId({ commit }, tax_id) {
      try {
        const response = await Vue.axios.post(
          `${process.env.VUE_APP_BACKEND}/api/v1/entrepreneur_business/BusinessInfoByTaxId`,
          { tax_id }
        );

        commit;
        return response.data;
      } catch (error) {
        console.error("Failed to fetch business info:", error);
        throw error;
      }
    },
    async insertJoinBiz({ commit }, data) {
      try {
        const response = await Vue.axios.post(
          `${process.env.VUE_APP_BACKEND}/api/v1/entrepreneur_business/insertUserIntoBiz`,
          data,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        commit;
        return response;
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
    async sendEmailJoinBiz({ commit }, data) {
      // const mailOptions = {
      //   recipients: data.recipientEmailList,
      //   cc: [],
      //   bcc: [],
      //   subject: `แจ้งเตือน BizID ลงทะเบียนซ้ำ`,
      //   html: `<h3>เรียนทีม Work life cycle</h3><p><br><b>${data.business_name_th}</b><span> </span><b>${data.tax_id}</b><br>ได้มีการลงทะเบียนซ้ำเข้ามา<br>
      //   รบกวนติดต่อ <b>${data.fullname}</b> <br><span>เบอร์โทร ${data.tel_number}</span> <br><span>อีเมล ${data.email}</span> <br><span>username ${data.username}</span><br><span>Account Id ${data.account_id}</span></p>`,
      //   email_type: "request to business",
      // };
      const mailOptions = {
        email_type: "request to business",
        biz_name: data.business_name_th,
        tax_id: data.tax_id,
        username: data.username,
        firstname: data.first_name_th,
        lastname: data.last_name_th,
        tel_no: data.tel_number,
        email: data.email,
      };
      await Vue.axios.post(
        `${process.env.VUE_APP_BACKEND}/api/v1/mailbox/inbox_email`,
        mailOptions
      );
      commit;
    },
    async sendEmailJoinBizLv0({ commit }, data) {
      const mailOptions = {
        email_type: "request to business lv0",
        biz_name: data.business_name_th,
        tax_id: data.tax_id,
        firstname: data.first_name_th,
        lastname: data.last_name_th,
        tel_no: data.mobile_no,
        email: data.email,
      };
      await Vue.axios.post(
        `${process.env.VUE_APP_BACKEND}/api/v1/mailbox/inbox_email`,
        mailOptions
      );
      commit;
    },
    async sendEmailRegisterBusiness({ commit }, data) {
      const site =
        process.env.VUE_APP_USE_THEME === "KKU_ADMIN" ? "KKU" : "WLC";
      const mailOptions = {
        firstname: data.first_name_th,
        lastname: data.last_name_th,
        tax_id: data.tax_id,
        biz_name: data.business_name_th,
        tel_no: data.mobile_no,
        email: data.email,
        email_type: "register new business",
        business_id: data.business_id,
        site,
      };
      await Vue.axios.post(
        `${process.env.VUE_APP_BACKEND}/api/v1/mailbox/inbox_email`,
        mailOptions
      );
      commit;
    },

    async sendEmailAnnounce({ commit }, data) {
      const refcode = localStorage.getItem("refcode");
      const sender_site = refcode === "moph" ? "MOPH" : "WLC";
      // const jobAmountText =
      //   data.data.recruitment.job_amount && data.data.recruitment.job_amount > 0
      //     ? `จำนวน ${data.data.recruitment.job_amount} คน`
      //     : "ไม่จำกัดอัตรา";

      // function formatDate(dateString) {
      //   if (!dateString) return null;
      //   const [year, month, day] = dateString.split("-");
      //   return `${day}-${month}-${year}`;
      // }

      // const jobStartDate = formatDate(data.data.job_start_date);
      // const jobEndDate = formatDate(data.data.job_end_date);

      // const ccEmails = data.cc?.email ? [{ address: data.cc.email }] : [];
      const mailOptions = {
        // recipients: data.recipientEmailList,
        // cc: ccEmails,
        // bcc: [],
        // subject: `ขอส่งประกาศรับสมัครเพื่อคัดเลือกเพื่อบรรจุบุคคลเข้ารับราชการ`,
        // html: `<p><p>เรียน เจ้าหน้าที่งานคัดเลือก กลุ่มงานสรรหาบุคคล</p><br>
        // <p>${data.data.recruitment.business_name_th} ขอส่งประกาศรับสมัครเพื่อคัดเลือกเพื่อบรรจุบุคคลเข้ารับราชการ เพื่อลงเว็บไซต์สำนักงาน ก.พ. และเว็บไซต์ กองบริหารทรัพยากรบุคคลค่ะ</p>
        // <br><p>ขอบคุณค่ะ</p></p>`,
        email_type: "post job active",
        // biz_recruit_id: data.data.recruitment.biz_recruit_id,
        // attachment: data.attachment,
        topic_id: data.data.topic_id,
        // employee_type_id: data.data.recruitment.employee_type,
        sender_site: sender_site,
      };

      try {
        await Vue.axios.post(
          `${process.env.VUE_APP_BACKEND}/api/v1/mailbox/send_email`,
          mailOptions
        );
        commit;
      } catch (error) {
        console.error("Error sending email:", error);
      }
    },

    async sendEmailRegisterPaymentPostJob({ commit }, data) {
      const refcode = localStorage.getItem("refcode");
      const sender_site = refcode === "moph" ? "MOPH" : "WLC";
      const mailOptions = {
        email_type: "register payment job fee",
        topic_id: data.data.topic_id,
        sender_site: sender_site,
      };

      try {
        await Vue.axios.post(
          `${process.env.VUE_APP_BACKEND}/api/v1/mailbox/send_email`,
          mailOptions
        );
        commit;
      } catch (error) {
        console.error("Error sending email:", error);
      }
    },

    async fetchServiceUnitTypes({ commit }) {
      commit("setLoading", true);
      try {
        const response = await Vue.axios.get(
          `${process.env.VUE_APP_BACKEND}/v1/advance_search/service_unit_type`
        );
        if (response.data.success) {
          commit("setServiceUnitTypes", response.data.data);
        } else {
          commit("setError", "Failed to fetch service unit types.");
        }
      } finally {
        commit("setLoading", false);
      }
    },

    async requestToJoin({ commit }, payload) {
      commit("setLoading", true);
      try {
        const response = await Vue.axios.post(
          `${process.env.VUE_APP_BACKEND}/api/v1/entrepreneur_business/insertUserIntoBiz`,
          payload
        );

        if (response.status === 200) {
          return { success: true, data: response.data };
        } else {
          console.error("Unexpected response:", response);
          return {
            success: false,
            message: "Unexpected response from the server.",
          };
        }
      } catch (error) {
        if (error) {
          return {
            success: false,
            message: error || "Failed to join the business.",
          };
        } else if (error.request) {
          return {
            success: false,
            message:
              "No response from the server. Please check your connection.",
          };
        } else {
          return { success: false, message: `Request error: ${error.message}` };
        }
      } finally {
        commit("setLoading", false);
      }
    },

    async fetchReferralSources({ commit }) {
      try {
        const response = await Vue.axios.get(
          `${process.env.VUE_APP_BACKEND}/v1/advance_search/referral_source`
        );

        if (response.data.success) {
          commit("setReferralSources", response.data.data);
        }
      } catch (error) {
        console.error("Error fetching referral sources:", error);
      }
    },
    async postBusinessUserReferral({ commit }, payload) {
      commit("setLoading", true);
      const token = localStorage.getItem("token");
      try {
        const response = await Vue.axios.post(
          `${process.env.VUE_APP_BACKEND}/api/v1/business_user/referral`,
          payload,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        if (response.data.success) {
          return response.data;
        } else {
          return null;
        }
      } catch (error) {
        return null;
      } finally {
        commit("setLoading", false);
      }
    },
    async checkKeywordPath({ commit }, keyword) {
      try {
        const business_id = localStorage.getItem("business_id");
        const response = await Vue.axios.post(
          `${process.env.VUE_APP_BACKEND}/api/v1/business/public/check_duplicate_keyword`,
          { keyword: keyword, business_id: business_id }
        );

        commit;
        return response.data;
      } catch (error) {
        console.error("Failed to fetch keyword:", error);
      }
    },
    async getOverviewMoph({ commit }, data) {
      try {
        const { filter_type, year, min, max, ...bodyData } = data;
        const response = await Vue.axios.post(
          `${process.env.VUE_APP_BACKEND}/api/v1/business_dashboard/moph/overview`,
          bodyData,
          {
            params: {
              filter_type,
              year,
              min,
              max,
            },
          }
        );

        commit("setOverViewMoph", response.data.data);
        return response.data;
      } catch (error) {
        console.error("Failed to fetch overview:", error);
      }
    },
    async getHealthZoneSummary({ commit }, data) {
      try {
        const response = await Vue.axios.get(
          `${process.env.VUE_APP_BACKEND}/api/v1/business_dashboard/moph/health_zone_summary`,
          { params: data }
        );

        commit("setHealthZoneSummary", response.data);
        return response.data;
      } catch (error) {
        console.error("Failed to fetch health zone:", error);
      }
    },
    async getProvinceHealthZone({ commit }, data) {
      try {
        const response = await Vue.axios.get(
          `${process.env.VUE_APP_BACKEND}/api/v1/business_dashboard/moph/province_health_zone`,
          { params: data }
        );

        commit("setProvinceHealthZone", response.data.data);
        return response.data;
      } catch (error) {
        console.error("Failed to fetch province health zone:", error);
      }
    },
    async getTopPostZoneHealth({ commit }, data) {
      try {
        const response = await Vue.axios.get(
          `${process.env.VUE_APP_BACKEND}/api/v1/business_dashboard/moph/top_job_postings`,
          { params: data }
        );

        commit("setTopPostZone", response.data.data);
        return response.data;
      } catch (error) {
        console.error("Failed to fetch top post zone:", error);
      }
    },
    async getTopUserZoneHealth({ commit }, data) {
      try {
        const response = await Vue.axios.get(
          `${process.env.VUE_APP_BACKEND}/api/v1/business_dashboard/moph/top_applications`,
          { params: data }
        );

        commit("setTopUserZone", response.data.data);
        return response.data;
      } catch (error) {
        console.error("Failed to fetch top user zone:", error);
      }
    },
    async getHealthZone({ commit }, data) {
      try {
        const { filter_type, year, min, max, ...bodyData } = data;
        const response = await Vue.axios.post(
          `${process.env.VUE_APP_BACKEND}/api/v1/business_dashboard/moph/health_zone`,
          bodyData,
          {
            params: {
              filter_type,
              year,
              min,
              max,
            },
          }
        );

        commit("setAreaHealth", response.data.data);
        return response.data;
      } catch (error) {
        console.error("Failed to fetch area health zone:", error);
      }
    },
    async getProvinceByHealthZone({ commit }, data) {
      try {
        const { filter_type, year, min, max, ...bodyData } = data;
        const response = await Vue.axios.post(
          `${process.env.VUE_APP_BACKEND}/api/v1/business_dashboard/moph/province`,
          bodyData,
          {
            params: {
              filter_type,
              year,
              min,
              max,
            },
          }
        );

        commit("setProvinceHealth", response.data.data);
        return response.data;
      } catch (error) {
        console.error("Failed to fetch province health zone:", error);
      }
    },
    async getServiceTypeHealthZone({ commit }, data) {
      try {
        const { filter_type, year, min, max, ...bodyData } = data;
        const response = await Vue.axios.post(
          `${process.env.VUE_APP_BACKEND}/api/v1/business_dashboard/moph/service_unit_type`,
          bodyData,
          {
            params: {
              filter_type,
              year,
              min,
              max,
            },
          }
        );

        commit("setServiceTypeHealth", response.data.data);
        return response.data;
      } catch (error) {
        console.error("Failed to fetch service health zone:", error);
      }
    },
    async postTableMophDashboard({ commit }, data) {
      try {
        const { filter_type, year, min, max, ...bodyData } = data;
        const response = await Vue.axios.post(
          `${process.env.VUE_APP_BACKEND}/api/v1/business_dashboard/moph/health_job`,
          bodyData,
          {
            params: {
              filter_type,
              year,
              min,
              max,
            },
          }
        );

        commit("setAllDepartments", response.data);
        return response.data;
      } catch (error) {
        console.error("Failed to fetch table moph dashboard:", error);
      }
    },
    async exportReportMoph({ commit }, data) {
      try {
        const { min, max, year, filter_type, ...bodyData } = data;
        const response = await Vue.axios.post(
          `${process.env.VUE_APP_BACKEND}/api/v1/business_dashboard/moph/report`,
          bodyData,
          {
            params: {
              min,
              max,
              year,
              filter_type,
            },
          }
        );

        commit;
        return response.data;
      } catch (error) {
        console.error("Failed to fetch export report:", error);
      }
    },
    async getLastYearMoph({ commit }) {
      try {
        const response = await Vue.axios.get(
          `${process.env.VUE_APP_BACKEND}/api/v1/business_dashboard/moph/last_year`
        );

        commit("setLastYearHealth", response.data.data);
        return response.data;
      } catch (error) {
        console.error("Failed to fetch service health zone:", error);
      }
    },
    async downLoadZipFileResume({ commit }, data) {
      try {
        const response = await Vue.axios.post(
          `${process.env.VUE_APP_BACKEND}/api/v1/business_application/workmoph/zip_file_candidate`,
          data
        );

        commit;
        return response.data;
      } catch (error) {
        console.error("Failed to fetch candidate doc:", error);
      }
    },
    async getHealthRiderData({ commit }, data) {
      try {
        const response = await Vue.axios.get(
          `${process.env.VUE_APP_BACKEND}/api/v1/business_recruitment/health/rider`,
          { params: data }
        );

        commit;
        return response;
      } catch (error) {
        console.error("Failed to fetch health rider data:", error);
      }
    },
    async getJobHealthRiderById({ commit }, { business_id, id }) {
      try {
        const response = await Vue.axios.get(
          `${process.env.VUE_APP_BACKEND}/api/v1/business_recruitment/health_rider/detail?business_id=${business_id}&biz_recruit_id=${id}`
        );

        commit;
        return response;
      } catch (error) {
        console.error("Failed to fetch health rider data:", error);
      }
    },
    async createJobHealthRider({ commit }, data) {
      try {
        const response = await Vue.axios.post(
          `${process.env.VUE_APP_BACKEND}/api/v1/business_recruitment/health_rider`,
          data
        );

        commit;
        return { success: true, data: response.data };
      } catch (error) {
        console.log("create job:", error);
        throw error;
      }
    },
    async updateJobHealthRider({ commit }, data) {
      try {
        const response = await Vue.axios.put(
          `${process.env.VUE_APP_BACKEND}/api/v1/business_recruitment/health_rider`,
          data
        );

        commit;
        return { success: true, data: response.data };
      } catch (error) {
        console.log("create job:", error);
        throw error;
      }
    },
    async deleteHealthRiderJob({ commit }, { business_id, id }) {
      try {
        const response = await Vue.axios.delete(
          `${process.env.VUE_APP_BACKEND}/api/v1/business_recruitment/health_rider/${business_id}/${id}`
        );

        commit;
        return response.data;
      } catch (error) {
        console.error("Delete failed:", error);
        throw error;
      }
    },

    async updateUserStatusNiems({ dispatch }, { account_id, status }) {
      try {
        const response = await Vue.axios.post(
          `${process.env.VUE_APP_BACKEND}/api/v1/niems/admin/update_status/${account_id}`,
          { status }
        );

        await dispatch("getUserProfileByAccountIdNiems", { account_id });

        return response.data;
      } catch (error) {
        console.error("updateUserStatusNiems error:", error);
        throw error;
      }
    },
    async updateDocSkillStatus({ commit }, payload) {
      try {
        const { document_id, status, remark } = payload;

        if (!["approved", "rejected"].includes(status)) {
          throw new Error("Invalid status. Allowed: approved, rejected");
        }

        const requestBody = {
          status: status,
          remark: status === "rejected" ? remark : null,
        };

        const response = await Vue.axios.put(
          `${process.env.VUE_APP_BACKEND}/api/v1/niems/admin/user_profile/doccument/${document_id}`,
          requestBody
        );
        commit;
        return response.data;
      } catch (error) {
        console.error("Error updating document status:", error);

        if (error.response) {
          const errorMessage =
            error.response.data?.message ||
            "เกิดข้อผิดพลาดในการอัปเดตสถานะเอกสาร";
          throw new Error(errorMessage);
        } else if (error.request) {
          throw new Error("ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้");
        } else {
          throw new Error(error.message || "เกิดข้อผิดพลาดที่ไม่ทราบสาเหตุ");
        }
      }
    },
    async updateUserStatus(
      { commit },
      { account_id, status, member_number = null, remark = null }
    ) {
      try {
        let requestBody = {};

        if (status === "approved") {
          requestBody = {
            preview_number: member_number,
            status: "approved",
            remark: null,
          };
        } else if (status === "rejected") {
          requestBody = {
            status: "rejected",
            remark: remark || "ไม่อนุมัติ",
          };
        }

        const response = await Vue.axios.put(
          `${process.env.VUE_APP_BACKEND}/api/v1/niems/admin/update_status/${account_id}`,
          requestBody
        );

        commit;
        return { success: true, data: response.data };
      } catch (error) {
        console.log("update user status error:", error);
        throw error;
      }
    },
    async previewMemberNumber({ commit }, payload) {
      try {
        const response = await Vue.axios.get(
          `${process.env.VUE_APP_BACKEND}/api/v1/niems/admin/preview_member/${payload.account_id}`,
          {
            headers: {
              Authorization: `Bearer ${
                payload.token || localStorage.getItem("token")
              }`,
            },
          }
        );

        commit("SET_MEMBER_NUMBER", response.data.data.member_number);

        return response.data;
      } catch (error) {
        console.error("Error fetching member number preview:", error);
        throw error;
      }
    },
    async checkMemberNumber({ commit }, payload) {
      try {
        let response = await Vue.axios.get(
          `${process.env.VUE_APP_BACKEND}/api/v1/niems/admin/check_member_number`,
          {
            params: {
              number_code: payload.number_code,
            },
          }
        );
        commit;
        return response.data;
      } catch (error) {
        console.error("Error checking member number:", error);
        throw error;
      }
    },
    async updateMemberNumber({ commit }, { account_id, new_member_number }) {
      try {
        const response = await Vue.axios.put(
          `${process.env.VUE_APP_BACKEND}/api/v1/niems/admin/member/${account_id}/member-number`,
          {
            new_member_number: new_member_number,
          },
          {
            headers: {
              authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

        commit;
        return response.data;
      } catch (error) {
        console.error("Error updating member number:", error);
        throw error;
      }
    },

    async getSubDistrictsData({ commit }, districtCodes) {
      try {
        const response = await Vue.axios.post(
          `${process.env.VUE_APP_BACKEND}/api/v1/map/subDistricts`,
          { districtCode: districtCodes }
        );

        commit;
        return { success: true, data: response.data };
      } catch (error) {
        console.log("create job:", error);
        throw error;
      }
    },
    openLoginDialog({ commit }) {
      commit("SET_LOGIN_DIALOG", true);
    },
    closeLoginDialog({ commit }) {
      commit("SET_LOGIN_DIALOG", false);
    },

    async createMemberID({ commit }, memberNumber) {
      try {
        const response = await Vue.axios.post(
          `${process.env.VUE_APP_BACKEND}/api/v1/niems/admin/create_member`,
          { member_number: memberNumber },
          {
            headers: {
              authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

        commit;
        return { success: true, data: response.data };
      } catch (error) {
        if (error.response && error.response.status === 400) {
          return {
            success: false,
            message:
              error.response.data.message ||
              "Duplicate member number. Please try again.",
            code: 400,
          };
        }

        throw error;
      }
    },

    async getTotalMemberId({ commit }, payload) {
      try {
        const queryParams = new URLSearchParams();

        if (payload.keyword) {
          queryParams.append("keyword", payload.keyword);
        }

        if (payload.page) {
          queryParams.append("page", payload.page);
        }

        if (payload.limit) {
          queryParams.append("limit", payload.limit);
        }

        if (payload.status) {
          queryParams.append("status", payload.status);
        }

        const queryString = queryParams.toString();
        const url = `${
          process.env.VUE_APP_BACKEND
        }/api/v1/niems/admin/total_member_id${
          queryString ? "?" + queryString : ""
        }`;

        const response = await Vue.axios.get(url, {
          headers: {
            Authorization: `Bearer ${
              payload.token || localStorage.getItem("token")
            }`,
          },
        });

        commit;
        return response.data;
      } catch (error) {
        console.error("Error fetching total member ID list:", error);
        throw error;
      }
    },

    async deleteMemberId({ commit }, payload) {
      try {
        const response = await Vue.axios.delete(
          `${process.env.VUE_APP_BACKEND}/api/v1/niems/admin/delete_member/${payload.member_id}`,
          {
            headers: {
              Authorization: `Bearer ${
                payload.token || localStorage.getItem("token")
              }`,
            },
          }
        );

        commit;
        return response.data;
      } catch (error) {
        console.error("Error deleting member ID:", error);
        throw error;
      }
    },
    async getPaymentRejectReasons({ commit }) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/v1/advance_search/payment_reject_reasons`
      );
      commit("SET_PAYMENT_REJECT_REASONS", response.data.data);
    },
    async getPaymentReceiptDetail({ commit }, app_id) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_application/workmoph/payment_detail/${app_id}`
      );
      commit("SET_PAYMENT_RECEIPT_DETAIL", response.data.data);
    },
    async updatePaymentApprove({ commit }, { app_payment_id, data }) {
      try {
        const response = await Vue.axios.put(
          `${process.env.VUE_APP_BACKEND}/api/v1/business_application/workmoph/payment_approval/${app_payment_id}`,
          data
        );

        commit;
        return response.data;
      } catch (error) {
        console.error("Error updating payment aprrove:", error);
        throw error;
      }
    },
    async getApplicationPayment({ commit }, params) {
      const {
        biz_recruit_id,
        status = "",
        search = "",
        payment_status = "",
        page = 1,
        limit_per_page = 10,
        sort_by = "",
      } = params;

      try {
        const response = await Vue.axios.post(
          `${process.env.VUE_APP_BACKEND}/api/v1/business_application/workmoph/payment_detail/receipt/${biz_recruit_id}`,
          {
            status,
            search,
            payment_status,
            page,
            limit_per_page,
            sort_by,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        commit("SET_APPLICATION_PAYMENT", response.data);
      } catch (error) {
        console.error("Failed to fetch application payment:", error);
      }
    },
    async getCertificateTypes({ commit }) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/v1/advance_search/fairoo/certificate-types`
      );
      commit("SET_Certificate_Types", response.data.data);
    },
    async getArticleJobTypes({ commit }) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/v1/advance_search/fairoo/article-job-types`
      );
      commit("SET_Article_Job_Types", response.data.data);
    },
    async getArticleTypes({ commit }) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/v1/advance_search/fairoo/article-types`
      );
      commit("SET_Article_Types", response.data.data);
    },
    // async saveWorkpartData({ commit, data }) {
    //   console.log("data", data)
    //   commit
    // },
    async getDetailJobFairoo({ commit }) {
      const biz_recruit_fairoo_id = localStorage.getItem(
        "biz_recruit_fairoo_id"
      );
      const token = localStorage.getItem("token");

      try {
        const response = await Vue.axios.get(
          `${process.env.VUE_APP_BACKEND}/api/v1/business_recruitment/fairoo/detail_job/${biz_recruit_fairoo_id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        if (response.data && response.data.success) {
          const data = response.data.data;

          // สร้าง draft
          const workpartDetailDraft = {
            recruitment_detail: data.recruitment_detail,
            document_files: data.document_files || [],
            customer_detail: data.customer_detail,
            applications: data.applications || {},
          };

          // Commit ทีเดียว
          commit("SET_JobFairoo_Detail", data); // สำคัญ!
          commit("setWorkPartDetail", workpartDetailDraft);

          // ADD_FILE ถ้ามี
          if (workpartDetailDraft.document_files.length > 0) {
            workpartDetailDraft.document_files.forEach((file) => {
              commit("ADD_FILE", file);
            });
          }
        }
      } catch (error) {
        console.error("Error fetching jobFairoo_detail:", error);
      }
    },
    async deleteJobFairoo({ commit }) {
      const biz_recruit_fairoo_id = localStorage.getItem(
        "biz_recruit_fairoo_id"
      );
      const token = localStorage.getItem("token");
      try {
        const response = await Vue.axios.delete(
          `${process.env.VUE_APP_BACKEND}/api/v1/business_recruitment/fairoo/soft_delete/${biz_recruit_fairoo_id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        commit;
        // commit("offLoading");
        // console.log(response.data)
        return response.data;
      } catch (error) {
        console.error("Delete failed:", error);
        throw error;
      }
    },
    async updateFairooJobViewStatus({ commit }, { biz_id, status }) {
      const token = localStorage.getItem("token");

      try {
        const response = await Vue.axios.put(
          `${process.env.VUE_APP_BACKEND}/api/v1/business_recruitment/fairoo/update_view_status/${biz_id}`,
          { job_status: status },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        commit;
        return response.data;
      } catch (error) {
        console.error("Error updating job view status:", error);
        throw error;
      }
    },
    async bookmarkProfileApplicantFairoo({ commit }, { payload }) {
      const token = localStorage.getItem("token");

      try {
        const response = await Vue.axios.put(
          `${process.env.VUE_APP_BACKEND}/api/v1/business_applicant/profile_bookmark_fairoo`,
          payload,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        commit;
        return response.data;
      } catch (error) {
        console.error("Error updating bookmark status:", error);
        throw error;
      }
    },
    async getProgramTrainingByBusiness({ commit }, { business_id, params }) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_recruitment/niems-trainings/${business_id}`,
        { params }
      );
      commit("SET_PROGRAM_TRAINING", response.data.data);
      return response;
    },
    async getProgramTrainingByBiz({ commit }, biz_recruit_id) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_recruitment/niems-trainings-detail/${biz_recruit_id}`
      );
      let data = response.data.data;

      const formattedData = {
        ...data,
        job_position_obj: {
          job_position: data.job_position || null,
          job_position_id: data.job_position_id || null,
          has_fee: !!data.fee,
          fee: data.fee ? Number(data.fee) : 0,
        },
      };

      commit("SET_PROGRAM_TRAINING_DETAILS", formattedData);
      return formattedData;
    },
    createProgramTraining({ commit }, data) {
      const payload = { ...data };

      if (
        payload.responsible_data &&
        typeof payload.responsible_data.full_name === "object"
      ) {
        payload.payment_data.full_name = payload.payment_data.full_name.name;
      }

      const response = Vue.axios.post(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_recruitment/niems-trainings`,
        payload
      );

      commit;
      return response;
    },
    editProgramTraining({ commit }, { biz_recruit_id, data }) {
      const response = Vue.axios.put(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_recruitment/niems-trainings/update/${data.business_id}/${biz_recruit_id}`,
        data
      );
      commit;
      return response;
    },
    async getMajorProgram({ commit }, params) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_recruitment/niems-trainings/major`,
        { params }
      );
      commit("SET_MAJOR_PROGRAM", response.data.data);
      return response;
    },
    async getOrganizeProgram({ commit }, params) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_recruitment/niems-trainings/organizations-programs`,
        {
          params,
        }
      );

      commit("SET_ORGANIZE_PROGRAM", response.data.data);
      return response;
    },
    async getLeaderTeacher({ commit }, params) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_recruitment/niems-trainings/lead-teacher
        `,
        { params }
      );
      commit("SET_LEADER_TEACHER", response.data.data);
      return response;
    },
    async getOperationUnit({ commit }, params) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_recruitment/niems-trainings/operation-unit`,
        { params }
      );
      commit("SET_OPERATION_UNIT", response.data.data);
      return response;
    },
    async getOperationPersonal({ commit }, params) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_recruitment/niems-trainings/operation-personnel`,
        { params }
      );
      commit("SET_OPERATION_PERSONAL", response.data.data);
      return response;
    },
    async getUserProgramByBiz({ commit }, { biz_recruit_id, params }) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_application/niems-trainings/${biz_recruit_id}`,
        { params }
      );
      commit("SET_USER_PROGRAM", response.data.data);
      return response;
    },
    async getUserAppByBiz({ commit }, app_id) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_application/niems-trainings/candidate_detail/${app_id}`
      );
      commit("SET_USER_APP", response.data.data);
      return response;
    },
    async getUserAppPaymentByBiz({ commit }, app_id) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_application/niems-trainings/payment_detail/${app_id}`
      );
      commit("SET_PAYMENT_RECEIPT_DETAIL", response.data.data);
      return response;
    },
    async getTrainingAssessmentsByApp({ commit }, app_id) {
      commit("SET_ASSESSMENT_LOADING", true);
      commit("SET_ASSESSMENT_ERROR", null);

      try {
        const token = localStorage.getItem("token");

        const response = await Vue.axios.get(
          `${process.env.VUE_APP_BACKEND}/api/v1/business_application/niems-trainings/assessments/${app_id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.data.success) {
          commit("SET_TRAINING_ASSESSMENTS", response.data.data);
          return response.data;
        } else {
          const errorMsg =
            response.data.message || "Failed to fetch training assessments";
          commit("SET_ASSESSMENT_ERROR", errorMsg);
          throw new Error(errorMsg);
        }
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message;
        commit("SET_ASSESSMENT_ERROR", errorMessage);
        console.error("Error fetching training assessments:", error);
        throw error;
      } finally {
        commit("SET_ASSESSMENT_LOADING", false);
      }
    },
    async submitAssessmentLink({ commit }, { exam_id, app_id, assessment_id }) {
      try {
        const token = localStorage.getItem("token");

        if (!token) {
          throw new Error("ไม่พบ token กรุณาเข้าสู่ระบบใหม่");
        }

        const response = await Vue.axios.post(
          `${process.env.VUE_APP_BACKEND}/api/v1/business_application/niems-trainings/assessment_link`,
          {
            exam_id,
            app_id: parseInt(app_id),
            assessment_id,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        commit;
        return response.data;
      } catch (error) {
        console.error("Error in submitAssessmentLink:", error);
        console.error("Error response:", error.response?.data);
        throw error;
      }
    },
    async updateStatusUserApp({ commit }, { payload }) {
      const response = await Vue.axios.put(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_application`,
        payload
      );
      commit;
      return response;
    },
    async checkBatchTraining({ commit }, payload) {
      const response = await Vue.axios.post(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_recruitment/niems-trainings-check/batch-no`,
        payload
      );
      commit;
      return response;
    },
    uploadAnnouncement({ commit }, data) {
      const payload = { ...data };

      const response = Vue.axios.post(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_recruitment/niems-trainings/upload-announcement`,
        payload
      );
      commit;
      return response;
    },
    uploadCertAndReceipt({ commit }, data) {
      const payload = { ...data };

      const response = Vue.axios.post(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_recruitment/niems-trainings/upload/cert-receipt`,
        payload
      );

      commit;
      return response;
    },
    approveUserPayment({ commit }, data) {
      const response = Vue.axios.put(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_application/niems-trainings/payment_approval`,
        data
      );

      commit;
      return response;
    },
    upDateApprovedToPayment({ commit }, biz_recruit_id) {
      const response = Vue.axios.put(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_recruitment/niems-trainings/waiting-payment/update/${biz_recruit_id}`
      );

      commit;
      return response;
    },
    upDatePaymentToAssessment({ commit }, biz_recruit_id) {
      const response = Vue.axios.put(
        `${process.env.VUE_APP_BACKEND}/api/v1/business_recruitment/niems-trainings/waiting-assessment/update/${biz_recruit_id}`
      );

      commit;
      return response;
    },
    async submitAssessmentResult({ commit }, payload) {
      try {
        const response = await Vue.axios.post(
          `${process.env.VUE_APP_BACKEND}/api/v1/business_application/niems-trainings/assessment_submission`,
          {
            ...payload,
            app_id: parseInt(payload.app_id),
            assessment_id: parseInt(payload.assessment_id),
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              "Content-Type": "application/json",
            },
          }
        );
        commit;
        return response.data;
      } catch (error) {
        console.error("Error submitting assessment:", error);
        throw error;
      }
    },
    async getSubmissionsList({ commit }, { app_id, params }) {
      try {
        const response = await Vue.axios.get(
          `${process.env.VUE_APP_BACKEND}/api/v1/business_application/niems-trainings/submissions/list/${app_id}`,
          { params }
        );
        commit;
        return response.data;
      } catch (error) {
        console.error("Error fetching submissions list:", error);
        throw error;
      }
    },
    async getAssessorList({ commit }, params) {
      try {
        const response = await Vue.axios.get(
          `${process.env.VUE_APP_BACKEND}/api/v1/business_recruitment/niems-trainings/assessor`,
          {
            params: {
              search: params?.search || "",
              biz_recruit_id: params?.biz_recruit_id || "",
              page: params?.page || 1,
              limit: params?.limit || 50,
            },
          }
        );
        commit("SET_ASSESSOR_LIST", response.data.data);
        return response;
      } catch (error) {
        console.error("Error fetching assessor list:", error);
        throw error;
      }
    },
    async submitAssessmentComplete({ commit }, { app_id }) {
      try {
        const token = localStorage.getItem("token");

        const response = await Vue.axios.put(
          `${process.env.VUE_APP_BACKEND}/api/v1/business_application/niems-trainings/assessment_submit/${app_id}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        commit;
        return response.data;
      } catch (error) {
        console.error("Error submitting assessment:", error);
        throw error;
      }
    },
    async updateAssessmentApproval({ commit }, { app_id }) {
      try {
        const token = localStorage.getItem("token");

        const response = await Vue.axios.put(
          `${process.env.VUE_APP_BACKEND}/api/v1/business_application/niems-trainings/assessment_approval/${app_id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        commit;
        return response.data;
      } catch (error) {
        console.error("Error submitting assessment:", error);
        throw error;
      }
    },
    async requestCertificate({ commit }, data) {
      try {
        const response = await Vue.axios.post(
          `${process.env.VUE_APP_BACKEND}/api/v1/business_application/niems-trainings/export_candidate/request_certificate`,
          data
        );

        commit;
        return response.data;
      } catch (error) {
        console.error("Error request certificate :", error);
        throw error;
      }
    },
    async getSignature({ commit }) {
      try {
        const response = await Vue.axios.get(
          `${process.env.VUE_APP_BACKEND}/api/v1/business_recruitment/niems-trainings/signature`
        );
        commit("SET_SIGNATURE", response.data.data);
        return response;
      } catch (error) {
        console.error("Error fetching signature:", error);
        throw error;
      }
    },
    async exportExcelTrainingUser({ commit }, { biz_recruit_id, status }) {
      try {
        const response = await Vue.axios.get(
          `${process.env.VUE_APP_BACKEND}/api/v1/business_application/niems-trainings/candidate_detail/excel/${biz_recruit_id}?status=${status}`
        );
        commit;
        return response;
      } catch (error) {
        console.error("Error fetching signature:", error);
        throw error;
      }
    },
    async getAnnounceMentData({ commit }, biz_recruit_id) {
      try {
        const response = await Vue.axios.get(
          `${process.env.VUE_APP_BACKEND}/api/v1/business_recruitment/niems-trainings/announcement-detail/${biz_recruit_id}`
        );

        commit("SET_ANNOUNCEMENT_DATA", response.data.data);
        return response;
      } catch (error) {
        console.error("Error fetching signature:", error);
        throw error;
      }
    },
    async getFairooUsersdropdown({ commit }, data) {
      const bizId = data.biz_id ? `?biz_recruit_id=${data.biz_id}` : "";
      console.log(data.business_id);
      console.log(bizId);
      try {
        const response = await Vue.axios.get(
          `${process.env.VUE_APP_BACKEND}/api/v1/business_recruitment/fairoo/dropdown/${data.business_id}${bizId}`
        );

        commit("SET_FAIROO_USERS_DROPDOWN", response.data.data);
        return response;
      } catch (error) {
        console.error("Error fetching data:", error);
        throw error;
      }
    },
    updateWorkpartAccountId({ commit }, account_id) {
      commit("UPDATE_WORKPART_ACCOUNT_ID", account_id);
    },
    async getUserMenuManual(_, siteName) {
      const response = await Vue.axios.get(
        `${process.env.VUE_APP_BACKEND}/api/v1/manual_documents/public`,
        {
          params: {
            site_name: siteName,
          },
        }
      );

      return response;
    },
    async getFairooJobsdropdown({ commit }, data) {
      try {
        const response = await Vue.axios.get(
          `${process.env.VUE_APP_BACKEND}/api/v1/business_recruitment/fairoo/dropdown_jobs/${data.business_id}?account_id=${data.account_id}`
        );

        commit("SET_JOB_DROPDOWN", response.data.data);
        return response;
      } catch (error) {
        console.error("Error fetching data:", error);
        throw error;
      }
    },
    async generateSWUOAuthUrl({ commit }) {
      try {
        const response = await Vue.axios.post(
          `${process.env.VUE_APP_BACKEND}/api/v1/business_oauth/google/generate-oauth-url`,
          { site: process.env.VUE_APP_USE_THEME }
        );
        commit;
        return response.data;
      } catch (error) {
        console.error("Error generating SWU OAuth URL:", error);
        throw error;
      }
    },

    async loginByGoogleSWU({ commit }, { code, state }) {
      try {
        commit("auth_request");
        const response = await Vue.axios.post(
          `${process.env.VUE_APP_BACKEND}/api/v1/business_oauth/google/login_swu`,
          { code, state }
        );

        if (!response.data.success) {
          commit("auth_error");
          return Promise.reject(response.data);
        }

        const { access_token, account_id, expiration_date, username } =
          response.data.data;

        commit("setAccountID", account_id);
        commit("auth_success", { token: access_token, user: username });
        commit("username", username);

        localStorage.setItem("token", access_token);
        localStorage.setItem("id_user", account_id);
        if (expiration_date) localStorage.setItem("exp_token", expiration_date);

        return response.data;
      } catch (error) {
        commit("auth_error");
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        localStorage.removeItem("id_user");

        const errData = error.response?.data || error;
        return Promise.reject(errData);
      }
    },
    RESET_STORE({ commit }) {
      const keys = [
        "token",
        "user",
        "role",
        "position_id",
        "business_id",
        "id_user",
        "role_training",
        "admin_preview",
        "callback",
      ];

      keys.forEach((k) => localStorage.removeItem(k));
      sessionStorage.clear();

      commit("RESET_STORE");
    },
  },
  modules: {},
});
